export const COUNTRY_DATA = [
    {
        phone: {
            mask: '##-###-####',
            dialCode: '+93',
            length: 9,
            fullMask: '+93-##-###-####',
            fullLength: 11,
        },
        currency: {
            name: 'Afghanistan',
            code: 'AFN',
            units: 0,
        },
        name: 'Afghanistan',
        countryCode: '004',
        iso3166: 'ISO 3166-2:AF',
        region: 'Asia',
        subRegion: 'Southern Asia',
        intermediateRegion: '',
        regionCode: '142',
        subRegionCode: '034',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_afghanistan',
        shortCountryNameKey: 'shortCountryNameKey_afghanistan',
        code2: 'AF',
        code3: 'AFG',
    },
    {
        phone: {
            mask: '(###)###-###',
            dialCode: '+355',
            length: 9,
            fullMask: '+355(###)###-###',
            fullLength: 12,
        },
        currency: {
            name: 'Lek',
            code: 'ALL',
            units: 2,
        },
        name: 'Albania',
        countryCode: '008',
        iso3166: 'ISO 3166-2:AL',
        region: 'Europe',
        subRegion: 'Southern Europe',
        intermediateRegion: '',
        regionCode: '150',
        subRegionCode: '039',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_albania',
        shortCountryNameKey: 'shortCountryNameKey_albania',
        code2: 'AL',
        code3: 'ALB',
    },
    {
        phone: {
            mask: '##-###-####',
            dialCode: '+213',
            length: 9,
            fullMask: '+213-##-###-####',
            fullLength: 12,
        },
        currency: {
            name: 'Algerian Dinar',
            code: 'DZD',
            units: 2,
        },
        name: 'Algeria',
        countryCode: '012',
        iso3166: 'ISO 3166-2:DZ',
        region: 'Africa',
        subRegion: 'Northern Africa',
        intermediateRegion: '',
        regionCode: '002',
        subRegionCode: '015',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_algeria',
        shortCountryNameKey: 'shortCountryNameKey_algeria',
        code2: 'DZ',
        code3: 'DZA',
    },
    {
        phone: {
            mask: '###-####',
            dialCode: '+1684',
            length: 7,
            fullMask: '+1(684)###-####',
            fullLength: 11,
        },
        currency: {
            name: 'American Samoa',
            code: 'USD',
            units: 0,
        },
        name: 'American Samoa',
        countryCode: '016',
        iso3166: 'ISO 3166-2:AS',
        region: 'Oceania',
        subRegion: 'Polynesia',
        intermediateRegion: '',
        regionCode: '009',
        subRegionCode: '061',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_american_samoa',
        shortCountryNameKey: 'shortCountryNameKey_american_samoa',
        code2: 'AS',
        code3: 'ASM',
    },
    {
        phone: {
            mask: '###-###',
            dialCode: '+376',
            length: 6,
            fullMask: '+376-###-###',
            fullLength: 9,
        },
        currency: {
            name: 'Andorra',
            code: 'EUR',
            units: 0,
        },
        name: 'Andorra',
        countryCode: '020',
        iso3166: 'ISO 3166-2:AD',
        region: 'Europe',
        subRegion: 'Southern Europe',
        intermediateRegion: '',
        regionCode: '150',
        subRegionCode: '039',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_andorra',
        shortCountryNameKey: 'shortCountryNameKey_andorra',
        code2: 'AD',
        code3: 'AND',
    },
    {
        phone: {
            mask: '(###)###-###',
            dialCode: '+244',
            length: 9,
            fullMask: '+244(###)###-###',
            fullLength: 12,
        },
        currency: {
            name: 'Angola',
            code: 'USD',
            units: 0,
        },
        name: 'Angola',
        countryCode: '024',
        iso3166: 'ISO 3166-2:AO',
        region: 'Africa',
        subRegion: 'Sub-Saharan Africa',
        intermediateRegion: 'Middle Africa',
        regionCode: '002',
        subRegionCode: '202',
        intermediateRegionCode: '017',
        countryNameKey: 'countryNameKey_angola',
        shortCountryNameKey: 'shortCountryNameKey_angola',
        code2: 'AO',
        code3: 'AGO',
    },
    {
        phone: {
            mask: '###-####',
            dialCode: '+1264',
            length: 7,
            fullMask: '+1(264)###-####',
            fullLength: 11,
        },
        currency: {
            name: 'Anguilla',
            code: 'USD',
            units: 0,
        },
        name: 'Anguilla',
        countryCode: '660',
        iso3166: 'ISO 3166-2:AI',
        region: 'Americas',
        subRegion: 'Latin America and the Caribbean',
        intermediateRegion: 'Caribbean',
        regionCode: '019',
        subRegionCode: '419',
        intermediateRegionCode: '029',
        countryNameKey: 'countryNameKey_anguilla',
        shortCountryNameKey: 'shortCountryNameKey_anguilla',
        code2: 'AI',
        code3: 'AIA',
    },
    {
        phone: {
            mask: '###-####',
            dialCode: '+1268',
            length: 7,
            fullMask: '+1(268)###-####',
            fullLength: 11,
        },
        currency: {
            name: 'Antigua and Barbuda',
            code: 'USD',
            units: 0,
        },
        name: 'Antigua and Barbuda',
        countryCode: '028',
        iso3166: 'ISO 3166-2:AG',
        region: 'Americas',
        subRegion: 'Latin America and the Caribbean',
        intermediateRegion: 'Caribbean',
        regionCode: '019',
        subRegionCode: '419',
        intermediateRegionCode: '029',
        countryNameKey: 'countryNameKey_antigua_&_barbuda',
        shortCountryNameKey: 'shortCountryNameKey_antigua_&_barbuda',
        code2: 'AG',
        code3: 'ATG',
    },
    {
        phone: {
            mask: '(###)###-####',
            dialCode: '+54',
            length: 10,
            fullMask: '+54(###)###-####',
            fullLength: 12,
        },
        currency: {
            name: 'Argentine Peso',
            code: 'ARS',
            units: 2,
        },
        name: 'Argentina',
        countryCode: '032',
        iso3166: 'ISO 3166-2:AR',
        region: 'Americas',
        subRegion: 'Latin America and the Caribbean',
        intermediateRegion: 'South America',
        regionCode: '019',
        subRegionCode: '419',
        intermediateRegionCode: '005',
        countryNameKey: 'countryNameKey_argentina',
        shortCountryNameKey: 'shortCountryNameKey_argentina',
        code2: 'AR',
        code3: 'ARG',
    },
    {
        phone: {
            mask: '##-###-###',
            dialCode: '+374',
            length: 8,
            fullMask: '+374-##-###-###',
            fullLength: 11,
        },
        currency: {
            name: 'Armenian Dram',
            code: 'AMD',
            units: 2,
        },
        name: 'Armenia',
        countryCode: '051',
        iso3166: 'ISO 3166-2:AM',
        region: 'Asia',
        subRegion: 'Western Asia',
        intermediateRegion: '',
        regionCode: '142',
        subRegionCode: '145',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_armenia',
        shortCountryNameKey: 'shortCountryNameKey_armenia',
        code2: 'AM',
        code3: 'ARM',
    },
    {
        phone: {
            mask: '###-####',
            dialCode: '+297',
            length: 7,
            fullMask: '+297-###-####',
            fullLength: 10,
        },
        currency: {
            name: 'Aruban Florin',
            code: 'AWG',
            units: 2,
        },
        name: 'Aruba',
        countryCode: '533',
        iso3166: 'ISO 3166-2:AW',
        region: 'Americas',
        subRegion: 'Latin America and the Caribbean',
        intermediateRegion: 'Caribbean',
        regionCode: '019',
        subRegionCode: '419',
        intermediateRegionCode: '029',
        countryNameKey: 'countryNameKey_aruba',
        shortCountryNameKey: 'shortCountryNameKey_aruba',
        code2: 'AW',
        code3: 'ABW',
    },
    {
        phone: {
            mask: '#-####-####',
            dialCode: '+61',
            length: 9,
            fullMask: '+61-#-####-####',
            fullLength: 11,
        },
        currency: {
            name: 'Australian Dollar',
            code: 'AUD',
            units: 2,
        },
        name: 'Australia',
        countryCode: '036',
        iso3166: 'ISO 3166-2:AU',
        region: 'Oceania',
        subRegion: 'Australia and New Zealand',
        intermediateRegion: '',
        regionCode: '009',
        subRegionCode: '053',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_australia',
        shortCountryNameKey: 'shortCountryNameKey_australia',
        code2: 'AU',
        code3: 'AUS',
    },
    {
        phone: {
            mask: '##-###',
            dialCode: '+6721',
            length: 5,
            fullMask: '+672-1##-###',
            fullLength: 9,
        },
        currency: {
            name: 'Antarctica',
            code: 'XCD',
            units: 0,
        },
        name: 'Antarctica',
        countryCode: '010',
        iso3166: 'ISO 3166-2:AQ',
        region: '',
        subRegion: '',
        intermediateRegion: '',
        regionCode: '',
        subRegionCode: '',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_australian_bases_in_antarctica',
        shortCountryNameKey: 'shortCountryNameKey_australian_bases_in_antarctica',
        code2: 'AQ',
        code3: 'ATA',
    },
    {
        phone: {
            mask: '(###)###-####',
            dialCode: '+43',
            length: 10,
            fullMask: '+43(###)###-####',
            fullLength: 12,
        },
        currency: {
            name: 'Austria',
            code: 'EUR',
            units: 0,
        },
        name: 'Austria',
        countryCode: '040',
        iso3166: 'ISO 3166-2:AT',
        region: 'Europe',
        subRegion: 'Western Europe',
        intermediateRegion: '',
        regionCode: '150',
        subRegionCode: '155',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_austria',
        shortCountryNameKey: 'shortCountryNameKey_austria',
        code2: 'AT',
        code3: 'AUT',
    },
    {
        phone: {
            mask: '##-###-##-##',
            dialCode: '+994',
            length: 9,
            fullMask: '+994-##-###-##-##',
            fullLength: 12,
        },
        currency: {
            name: 'Azerbaijan',
            code: 'USD',
            units: 0,
        },
        name: 'Azerbaijan',
        countryCode: '031',
        iso3166: 'ISO 3166-2:AZ',
        region: 'Asia',
        subRegion: 'Western Asia',
        intermediateRegion: '',
        regionCode: '142',
        subRegionCode: '145',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_azerbaijan',
        shortCountryNameKey: 'shortCountryNameKey_azerbaijan',
        code2: 'AZ',
        code3: 'AZE',
    },
    {
        phone: {
            mask: '###-####',
            dialCode: '+1242',
            length: 7,
            fullMask: '+1(242)###-####',
            fullLength: 11,
        },
        currency: {
            name: 'Bahamian Dollar',
            code: 'BSD',
            units: 2,
        },
        name: 'Bahamas',
        countryCode: '044',
        iso3166: 'ISO 3166-2:BS',
        region: 'Americas',
        subRegion: 'Latin America and the Caribbean',
        intermediateRegion: 'Caribbean',
        regionCode: '019',
        subRegionCode: '419',
        intermediateRegionCode: '029',
        countryNameKey: 'countryNameKey_bahamas',
        shortCountryNameKey: 'shortCountryNameKey_bahamas',
        code2: 'BS',
        code3: 'BHS',
    },
    {
        phone: {
            mask: '####-####',
            dialCode: '+973',
            length: 8,
            fullMask: '+973-####-####',
            fullLength: 11,
        },
        currency: {
            name: 'Bahraini Dinar',
            code: 'BHD',
            units: 3,
        },
        name: 'Bahrain',
        countryCode: '048',
        iso3166: 'ISO 3166-2:BH',
        region: 'Asia',
        subRegion: 'Western Asia',
        intermediateRegion: '',
        regionCode: '142',
        subRegionCode: '145',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_bahrain',
        shortCountryNameKey: 'shortCountryNameKey_bahrain',
        code2: 'BH',
        code3: 'BHR',
    },
    {
        phone: {
            mask: '##-###-###',
            dialCode: '+880',
            length: 8,
            fullMask: '+880-##-###-###',
            fullLength: 11,
        },
        currency: {
            name: 'Taka',
            code: 'BDT',
            units: 2,
        },
        name: 'Bangladesh',
        countryCode: '050',
        iso3166: 'ISO 3166-2:BD',
        region: 'Asia',
        subRegion: 'Southern Asia',
        intermediateRegion: '',
        regionCode: '142',
        subRegionCode: '034',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_bangladesh',
        shortCountryNameKey: 'shortCountryNameKey_bangladesh',
        code2: 'BD',
        code3: 'BGD',
    },
    {
        phone: {
            mask: '###-####',
            dialCode: '+1246',
            length: 7,
            fullMask: '+1(246)###-####',
            fullLength: 11,
        },
        currency: {
            name: 'Barbados Dollar',
            code: 'BBD',
            units: 2,
        },
        name: 'Barbados',
        countryCode: '052',
        iso3166: 'ISO 3166-2:BB',
        region: 'Americas',
        subRegion: 'Latin America and the Caribbean',
        intermediateRegion: 'Caribbean',
        regionCode: '019',
        subRegionCode: '419',
        intermediateRegionCode: '029',
        countryNameKey: 'countryNameKey_barbados',
        shortCountryNameKey: 'shortCountryNameKey_barbados',
        code2: 'BB',
        code3: 'BRB',
    },
    {
        phone: {
            mask: '(##)###-##-##',
            dialCode: '+375',
            length: 9,
            fullMask: '+375(##)###-##-##',
            fullLength: 12,
        },
        currency: {
            name: 'Belarus',
            code: 'BYR',
            units: 0,
        },
        name: 'Belarus',
        countryCode: '112',
        iso3166: 'ISO 3166-2:BY',
        region: 'Europe',
        subRegion: 'Eastern Europe',
        intermediateRegion: '',
        regionCode: '150',
        subRegionCode: '151',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_belarus',
        shortCountryNameKey: 'shortCountryNameKey_belarus',
        code2: 'BY',
        code3: 'BLR',
    },
    {
        phone: {
            mask: '(###)###-###',
            dialCode: '+32',
            length: 9,
            fullMask: '+32(###)###-###',
            fullLength: 11,
        },
        currency: {
            name: 'Belgium',
            code: 'EUR',
            units: 0,
        },
        name: 'Belgium',
        countryCode: '056',
        iso3166: 'ISO 3166-2:BE',
        region: 'Europe',
        subRegion: 'Western Europe',
        intermediateRegion: '',
        regionCode: '150',
        subRegionCode: '155',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_belgium',
        shortCountryNameKey: 'shortCountryNameKey_belgium',
        code2: 'BE',
        code3: 'BEL',
    },
    {
        phone: {
            mask: '###-####',
            dialCode: '+501',
            length: 7,
            fullMask: '+501-###-####',
            fullLength: 10,
        },
        currency: {
            name: 'Belize Dollar',
            code: 'BZD',
            units: 2,
        },
        name: 'Belize',
        countryCode: '084',
        iso3166: 'ISO 3166-2:BZ',
        region: 'Americas',
        subRegion: 'Latin America and the Caribbean',
        intermediateRegion: 'Central America',
        regionCode: '019',
        subRegionCode: '419',
        intermediateRegionCode: '013',
        countryNameKey: 'countryNameKey_belize',
        shortCountryNameKey: 'shortCountryNameKey_belize',
        code2: 'BZ',
        code3: 'BLZ',
    },
    {
        phone: {
            mask: '##-##-####',
            dialCode: '+229',
            length: 8,
            fullMask: '+229-##-##-####',
            fullLength: 11,
        },
        currency: {
            name: 'Benin',
            code: 'USD',
            units: 0,
        },
        name: 'Benin',
        countryCode: '204',
        iso3166: 'ISO 3166-2:BJ',
        region: 'Africa',
        subRegion: 'Sub-Saharan Africa',
        intermediateRegion: 'Western Africa',
        regionCode: '002',
        subRegionCode: '202',
        intermediateRegionCode: '011',
        countryNameKey: 'countryNameKey_benin',
        shortCountryNameKey: 'shortCountryNameKey_benin',
        code2: 'BJ',
        code3: 'BEN',
    },
    {
        phone: {
            mask: '###-####',
            dialCode: '+1441',
            length: 7,
            fullMask: '+1(441)###-####',
            fullLength: 11,
        },
        currency: {
            name: 'Bermudian Dollar',
            code: 'BMD',
            units: 2,
        },
        name: 'Bermuda',
        countryCode: '060',
        iso3166: 'ISO 3166-2:BM',
        region: 'Americas',
        subRegion: 'Northern America',
        intermediateRegion: '',
        regionCode: '019',
        subRegionCode: '021',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_bermuda',
        shortCountryNameKey: 'shortCountryNameKey_bermuda',
        code2: 'BM',
        code3: 'BMU',
    },
    {
        phone: {
            mask: '#-###-###',
            dialCode: '+975',
            length: 7,
            fullMask: '+975-#-###-###',
            fullLength: 10,
        },
        currency: {
            name: 'Ngultrum',
            code: 'BTN',
            units: 2,
        },
        name: 'Bhutan',
        countryCode: '064',
        iso3166: 'ISO 3166-2:BT',
        region: 'Asia',
        subRegion: 'Southern Asia',
        intermediateRegion: '',
        regionCode: '142',
        subRegionCode: '034',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_bhutan',
        shortCountryNameKey: 'shortCountryNameKey_bhutan',
        code2: 'BT',
        code3: 'BTN',
    },
    {
        phone: {
            mask: '#-###-####',
            dialCode: '+591',
            length: 8,
            fullMask: '+591-#-###-####',
            fullLength: 11,
        },
        currency: {
            name: 'Boliviano',
            code: 'BOB',
            units: 2,
        },
        name: 'Bolivia (Plurinational State of)',
        countryCode: '068',
        iso3166: 'ISO 3166-2:BO',
        region: 'Americas',
        subRegion: 'Latin America and the Caribbean',
        intermediateRegion: 'South America',
        regionCode: '019',
        subRegionCode: '419',
        intermediateRegionCode: '005',
        countryNameKey: 'countryNameKey_bolivia',
        shortCountryNameKey: 'shortCountryNameKey_bolivia',
        code2: 'BO',
        code3: 'BOL',
    },
    {
        phone: {
            mask: '##-#####',
            dialCode: '+387',
            length: 7,
            fullMask: '+387-##-#####',
            fullLength: 10,
        },
        currency: {
            name: 'Bosnia and Herzegovina',
            code: 'USD',
            units: 0,
        },
        name: 'Bosnia and Herzegovina',
        countryCode: '070',
        iso3166: 'ISO 3166-2:BA',
        region: 'Europe',
        subRegion: 'Southern Europe',
        intermediateRegion: '',
        regionCode: '150',
        subRegionCode: '039',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_bosnia_and_herzegovina',
        shortCountryNameKey: 'shortCountryNameKey_bosnia_and_herzegovina',
        code2: 'BA',
        code3: 'BIH',
    },
    {
        phone: {
            mask: '##-###-###',
            dialCode: '+267',
            length: 8,
            fullMask: '+267-##-###-###',
            fullLength: 11,
        },
        currency: {
            name: 'Pula',
            code: 'BWP',
            units: 2,
        },
        name: 'Botswana',
        countryCode: '072',
        iso3166: 'ISO 3166-2:BW',
        region: 'Africa',
        subRegion: 'Sub-Saharan Africa',
        intermediateRegion: 'Southern Africa',
        regionCode: '002',
        subRegionCode: '202',
        intermediateRegionCode: '018',
        countryNameKey: 'countryNameKey_botswana',
        shortCountryNameKey: 'shortCountryNameKey_botswana',
        code2: 'BW',
        code3: 'BWA',
    },
    {
        phone: {
            mask: '(##)####-####',
            dialCode: '+55',
            length: 10,
            fullMask: '+55(##)####-####',
            fullLength: 12,
        },
        currency: {
            name: 'Brazil',
            code: 'BRL',
            units: 0,
        },
        name: 'Brazil',
        countryCode: '076',
        iso3166: 'ISO 3166-2:BR',
        region: 'Americas',
        subRegion: 'Latin America and the Caribbean',
        intermediateRegion: 'South America',
        regionCode: '019',
        subRegionCode: '419',
        intermediateRegionCode: '005',
        countryNameKey: 'countryNameKey_brazil',
        shortCountryNameKey: 'shortCountryNameKey_brazil',
        code2: 'BR',
        code3: 'BRA',
    },
    {
        phone: {
            mask: '###-####',
            dialCode: '+1284',
            length: 7,
            fullMask: '+1(284)###-####',
            fullLength: 11,
        },
        currency: {
            name: 'Virgin Islands, British',
            code: 'USD',
            units: 0,
        },
        name: 'Virgin Islands (British)',
        countryCode: '092',
        iso3166: 'ISO 3166-2:VG',
        region: 'Americas',
        subRegion: 'Latin America and the Caribbean',
        intermediateRegion: 'Caribbean',
        regionCode: '019',
        subRegionCode: '419',
        intermediateRegionCode: '029',
        countryNameKey: 'countryNameKey_british_virgin_islands',
        shortCountryNameKey: 'shortCountryNameKey_british_virgin_islands',
        code2: 'VG',
        code3: 'VGB',
    },
    {
        phone: {
            mask: '###-####',
            dialCode: '+673',
            length: 7,
            fullMask: '+673-###-####',
            fullLength: 10,
        },
        currency: {
            name: 'Brunei Dollar',
            code: 'BND',
            units: 2,
        },
        name: 'Brunei Darussalam',
        countryCode: '096',
        iso3166: 'ISO 3166-2:BN',
        region: 'Asia',
        subRegion: 'South-eastern Asia',
        intermediateRegion: '',
        regionCode: '142',
        subRegionCode: '035',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_brunei_darussalam',
        shortCountryNameKey: 'shortCountryNameKey_brunei_darussalam',
        code2: 'BN',
        code3: 'BRN',
    },
    {
        phone: {
            mask: '(###)###-###',
            dialCode: '+359',
            length: 9,
            fullMask: '+359(###)###-###',
            fullLength: 12,
        },
        currency: {
            name: 'Bulgaria',
            code: 'BGN',
            units: 0,
        },
        name: 'Bulgaria',
        countryCode: '100',
        iso3166: 'ISO 3166-2:BG',
        region: 'Europe',
        subRegion: 'Eastern Europe',
        intermediateRegion: '',
        regionCode: '150',
        subRegionCode: '151',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_bulgaria',
        shortCountryNameKey: 'shortCountryNameKey_bulgaria',
        code2: 'BG',
        code3: 'BGR',
    },
    {
        phone: {
            mask: '##-##-####',
            dialCode: '+226',
            length: 8,
            fullMask: '+226-##-##-####',
            fullLength: 11,
        },
        currency: {
            name: 'Burkina Faso',
            code: 'USD',
            units: 0,
        },
        name: 'Burkina Faso',
        countryCode: '854',
        iso3166: 'ISO 3166-2:BF',
        region: 'Africa',
        subRegion: 'Sub-Saharan Africa',
        intermediateRegion: 'Western Africa',
        regionCode: '002',
        subRegionCode: '202',
        intermediateRegionCode: '011',
        countryNameKey: 'countryNameKey_burkina_faso',
        shortCountryNameKey: 'shortCountryNameKey_burkina_faso',
        code2: 'BF',
        code3: 'BFA',
    },
    {
        phone: {
            mask: '##-###-###',
            dialCode: '+95',
            length: 8,
            fullMask: '+95-##-###-###',
            fullLength: 10,
        },
        currency: {
            name: 'Kyat',
            code: 'MMK',
            units: 2,
        },
        name: 'Myanmar',
        countryCode: '104',
        iso3166: 'ISO 3166-2:MM',
        region: 'Asia',
        subRegion: 'South-eastern Asia',
        intermediateRegion: '',
        regionCode: '142',
        subRegionCode: '035',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_burma_(myanmar)',
        shortCountryNameKey: 'shortCountryNameKey_burma_(myanmar)',
        code2: 'MM',
        code3: 'MMR',
    },
    {
        phone: {
            mask: '##-##-####',
            dialCode: '+257',
            length: 8,
            fullMask: '+257-##-##-####',
            fullLength: 11,
        },
        currency: {
            name: 'Burundi Franc',
            code: 'BIF',
            units: 0,
        },
        name: 'Burundi',
        countryCode: '108',
        iso3166: 'ISO 3166-2:BI',
        region: 'Africa',
        subRegion: 'Sub-Saharan Africa',
        intermediateRegion: 'Eastern Africa',
        regionCode: '002',
        subRegionCode: '202',
        intermediateRegionCode: '014',
        countryNameKey: 'countryNameKey_burundi',
        shortCountryNameKey: 'shortCountryNameKey_burundi',
        code2: 'BI',
        code3: 'BDI',
    },
    {
        phone: {
            mask: '##-###-###',
            dialCode: '+855',
            length: 8,
            fullMask: '+855-##-###-###',
            fullLength: 11,
        },
        currency: {
            name: 'Riel',
            code: 'KHR',
            units: 2,
        },
        name: 'Cambodia',
        countryCode: '116',
        iso3166: 'ISO 3166-2:KH',
        region: 'Asia',
        subRegion: 'South-eastern Asia',
        intermediateRegion: '',
        regionCode: '142',
        subRegionCode: '035',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_cambodia',
        shortCountryNameKey: 'shortCountryNameKey_cambodia',
        code2: 'KH',
        code3: 'KHM',
    },
    {
        phone: {
            mask: '####-####',
            dialCode: '+237',
            length: 8,
            fullMask: '+237-####-####',
            fullLength: 11,
        },
        currency: {
            name: 'Cameroon',
            code: 'USD',
            units: 0,
        },
        name: 'Cameroon',
        countryCode: '120',
        iso3166: 'ISO 3166-2:CM',
        region: 'Africa',
        subRegion: 'Sub-Saharan Africa',
        intermediateRegion: 'Middle Africa',
        regionCode: '002',
        subRegionCode: '202',
        intermediateRegionCode: '017',
        countryNameKey: 'countryNameKey_cameroon',
        shortCountryNameKey: 'shortCountryNameKey_cameroon',
        code2: 'CM',
        code3: 'CMR',
    },
    {
        phone: {
            mask: '(###)###-####',
            dialCode: '+1',
            length: 10,
            fullMask: '+1(###)###-####',
            fullLength: 11,
        },
        currency: {
            name: 'Canadian Dollar',
            code: 'CAD',
            units: 2,
        },
        name: 'Canada',
        countryCode: '124',
        iso3166: 'ISO 3166-2:CA',
        region: 'Americas',
        subRegion: 'Northern America',
        intermediateRegion: '',
        regionCode: '019',
        subRegionCode: '021',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_canada',
        shortCountryNameKey: 'shortCountryNameKey_canada',
        code2: 'CA',
        code3: 'CAN',
    },
    {
        phone: {
            mask: '(###)##-##',
            dialCode: '+238',
            length: 7,
            fullMask: '+238(###)##-##',
            fullLength: 10,
        },
        currency: {
            name: 'Cabo Verde Escudo',
            code: 'CVE',
            units: 2,
        },
        name: 'Cabo Verde',
        countryCode: '132',
        iso3166: 'ISO 3166-2:CV',
        region: 'Africa',
        subRegion: 'Sub-Saharan Africa',
        intermediateRegion: 'Western Africa',
        regionCode: '002',
        subRegionCode: '202',
        intermediateRegionCode: '011',
        countryNameKey: 'countryNameKey_cape_verde',
        shortCountryNameKey: 'shortCountryNameKey_cape_verde',
        code2: 'CV',
        code3: 'CPV',
    },
    {
        phone: {
            mask: '###-####',
            dialCode: '+1345',
            length: 7,
            fullMask: '+1(345)###-####',
            fullLength: 11,
        },
        currency: {
            name: 'Cayman Islands Dollar',
            code: 'KYD',
            units: 2,
        },
        name: 'Cayman Islands',
        countryCode: '136',
        iso3166: 'ISO 3166-2:KY',
        region: 'Americas',
        subRegion: 'Latin America and the Caribbean',
        intermediateRegion: 'Caribbean',
        regionCode: '019',
        subRegionCode: '419',
        intermediateRegionCode: '029',
        countryNameKey: 'countryNameKey_cayman_islands',
        shortCountryNameKey: 'shortCountryNameKey_cayman_islands',
        code2: 'KY',
        code3: 'CYM',
    },
    {
        phone: {
            mask: '##-##-####',
            dialCode: '+236',
            length: 8,
            fullMask: '+236-##-##-####',
            fullLength: 11,
        },
        currency: {
            name: 'Central African Republic',
            code: 'USD',
            units: 0,
        },
        name: 'Central African Republic',
        countryCode: '140',
        iso3166: 'ISO 3166-2:CF',
        region: 'Africa',
        subRegion: 'Sub-Saharan Africa',
        intermediateRegion: 'Middle Africa',
        regionCode: '002',
        subRegionCode: '202',
        intermediateRegionCode: '017',
        countryNameKey: 'countryNameKey_central_african_republic',
        shortCountryNameKey: 'shortCountryNameKey_central_african_republic',
        code2: 'CF',
        code3: 'CAF',
    },
    {
        phone: {
            mask: '##-##-##-##',
            dialCode: '+235',
            length: 8,
            fullMask: '+235-##-##-##-##',
            fullLength: 11,
        },
        currency: {
            name: 'Chad',
            code: 'USD',
            units: 0,
        },
        name: 'Chad',
        countryCode: '148',
        iso3166: 'ISO 3166-2:TD',
        region: 'Africa',
        subRegion: 'Sub-Saharan Africa',
        intermediateRegion: 'Middle Africa',
        regionCode: '002',
        subRegionCode: '202',
        intermediateRegionCode: '017',
        countryNameKey: 'countryNameKey_chad',
        shortCountryNameKey: 'shortCountryNameKey_chad',
        code2: 'TD',
        code3: 'TCD',
    },
    {
        phone: {
            mask: '#-####-####',
            dialCode: '+56',
            length: 9,
            fullMask: '+56-#-####-####',
            fullLength: 11,
        },
        currency: {
            name: 'Chilean Peso',
            code: 'CLP',
            units: 0,
        },
        name: 'Chile',
        countryCode: '152',
        iso3166: 'ISO 3166-2:CL',
        region: 'Americas',
        subRegion: 'Latin America and the Caribbean',
        intermediateRegion: 'South America',
        regionCode: '019',
        subRegionCode: '419',
        intermediateRegionCode: '005',
        countryNameKey: 'countryNameKey_chile',
        shortCountryNameKey: 'shortCountryNameKey_chile',
        code2: 'CL',
        code3: 'CHL',
    },
    {
        phone: {
            mask: '(###)####-###',
            dialCode: '+86',
            length: 10,
            fullMask: '+86(###)####-###',
            fullLength: 12,
        },
        currency: {
            name: 'Chinese Yuan',
            code: 'CNY',
            units: 2,
        },
        name: 'China',
        countryCode: '156',
        iso3166: 'ISO 3166-2:CN',
        region: 'Asia',
        subRegion: 'Eastern Asia',
        intermediateRegion: '',
        regionCode: '142',
        subRegionCode: '030',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_china_(prc)',
        shortCountryNameKey: 'shortCountryNameKey_china_(prc)',
        code2: 'CN',
        code3: 'CHN',
    },
    {
        phone: {
            mask: '(###)###-####',
            dialCode: '+57',
            length: 10,
            fullMask: '+57(###)###-####',
            fullLength: 12,
        },
        currency: {
            name: 'Colombian Peso',
            code: 'COP',
            units: 2,
        },
        name: 'Colombia',
        countryCode: '170',
        iso3166: 'ISO 3166-2:CO',
        region: 'Americas',
        subRegion: 'Latin America and the Caribbean',
        intermediateRegion: 'South America',
        regionCode: '019',
        subRegionCode: '419',
        intermediateRegionCode: '005',
        countryNameKey: 'countryNameKey_colombia',
        shortCountryNameKey: 'shortCountryNameKey_colombia',
        code2: 'CO',
        code3: 'COL',
    },
    {
        phone: {
            mask: '##-#####',
            dialCode: '+269',
            length: 7,
            fullMask: '+269-##-#####',
            fullLength: 10,
        },
        currency: {
            name: 'Comorian Franc',
            code: 'KMF',
            units: 0,
        },
        name: 'Comoros',
        countryCode: '174',
        iso3166: 'ISO 3166-2:KM',
        region: 'Africa',
        subRegion: 'Sub-Saharan Africa',
        intermediateRegion: 'Eastern Africa',
        regionCode: '002',
        subRegionCode: '202',
        intermediateRegionCode: '014',
        countryNameKey: 'countryNameKey_comoros',
        shortCountryNameKey: 'shortCountryNameKey_comoros',
        code2: 'KM',
        code3: 'COM',
    },
    {
        phone: {
            mask: '##-###-####',
            dialCode: '+242',
            length: 9,
            fullMask: '+242-##-###-####',
            fullLength: 12,
        },
        currency: {
            name: 'Congo',
            code: 'USD',
            units: 0,
        },
        name: 'Congo',
        countryCode: '178',
        iso3166: 'ISO 3166-2:CG',
        region: 'Africa',
        subRegion: 'Sub-Saharan Africa',
        intermediateRegion: 'Middle Africa',
        regionCode: '002',
        subRegionCode: '202',
        intermediateRegionCode: '017',
        countryNameKey: 'countryNameKey_congo_(brazzaville)',
        shortCountryNameKey: 'shortCountryNameKey_congo_(brazzaville)',
        code2: 'CG',
        code3: 'COG',
    },
    {
        phone: {
            mask: '##-###',
            dialCode: '+682',
            length: 5,
            fullMask: '+682-##-###',
            fullLength: 8,
        },
        currency: {
            name: 'Cook Islands',
            code: 'USD',
            units: 0,
        },
        name: 'Cook Islands',
        countryCode: '184',
        iso3166: 'ISO 3166-2:CK',
        region: 'Oceania',
        subRegion: 'Polynesia',
        intermediateRegion: '',
        regionCode: '009',
        subRegionCode: '061',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_cook_islands',
        shortCountryNameKey: 'shortCountryNameKey_cook_islands',
        code2: 'CK',
        code3: 'COK',
    },
    {
        phone: {
            mask: '####-####',
            dialCode: '+506',
            length: 8,
            fullMask: '+506-####-####',
            fullLength: 11,
        },
        currency: {
            name: 'Costa Rican Colon',
            code: 'CRC',
            units: 2,
        },
        name: 'Costa Rica',
        countryCode: '188',
        iso3166: 'ISO 3166-2:CR',
        region: 'Americas',
        subRegion: 'Latin America and the Caribbean',
        intermediateRegion: 'Central America',
        regionCode: '019',
        subRegionCode: '419',
        intermediateRegionCode: '013',
        countryNameKey: 'countryNameKey_costa_rica',
        shortCountryNameKey: 'shortCountryNameKey_costa_rica',
        code2: 'CR',
        code3: 'CRI',
    },
    {
        phone: {
            mask: '##-###-###',
            dialCode: '+225',
            length: 8,
            fullMask: '+225-##-###-###',
            fullLength: 11,
        },
        currency: {
            name: 'Côte d\'Ivoire',
            code: 'USD',
            units: 0,
        },
        name: 'Côte d\'Ivoire',
        countryCode: '384',
        iso3166: 'ISO 3166-2:CI',
        region: 'Africa',
        subRegion: 'Sub-Saharan Africa',
        intermediateRegion: 'Western Africa',
        regionCode: '002',
        subRegionCode: '202',
        intermediateRegionCode: '011',
        countryNameKey: 'countryNameKey_cote_d’ivoire (ivory_coast)',
        shortCountryNameKey: 'shortCountryNameKey_cote_d’ivoire (ivory_coast)',
        code2: 'CI',
        code3: 'CIV',
    },
    {
        phone: {
            mask: '##-###-###',
            dialCode: '+385',
            length: 8,
            fullMask: '+385-##-###-###',
            fullLength: 11,
        },
        currency: {
            name: 'Kuna',
            code: 'HRK',
            units: 2,
        },
        name: 'Croatia',
        countryCode: '191',
        iso3166: 'ISO 3166-2:HR',
        region: 'Europe',
        subRegion: 'Southern Europe',
        intermediateRegion: '',
        regionCode: '150',
        subRegionCode: '039',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_croatia',
        shortCountryNameKey: 'shortCountryNameKey_croatia',
        code2: 'HR',
        code3: 'HRV',
    },
    {
        phone: {
            mask: '#-###-####',
            dialCode: '+53',
            length: 8,
            fullMask: '+53-#-###-####',
            fullLength: 10,
        },
        currency: {
            name: 'Cuban Peso',
            code: 'CUP',
            units: 2,
        },
        name: 'Cuba',
        countryCode: '192',
        iso3166: 'ISO 3166-2:CU',
        region: 'Americas',
        subRegion: 'Latin America and the Caribbean',
        intermediateRegion: 'Caribbean',
        regionCode: '019',
        subRegionCode: '419',
        intermediateRegionCode: '029',
        countryNameKey: 'countryNameKey_cuba',
        shortCountryNameKey: 'shortCountryNameKey_cuba',
        code2: 'CU',
        code3: 'CUB',
    },
    {
        phone: {
            mask: '###-####',
            dialCode: '+599',
            length: 7,
            fullMask: '+599-###-####',
            fullLength: 10,
        },
        currency: {
            name: 'Curaçao',
            code: 'USD',
            units: 0,
        },
        name: 'Curaçao',
        countryCode: '531',
        iso3166: 'ISO 3166-2:CW',
        region: 'Americas',
        subRegion: 'Latin America and the Caribbean',
        intermediateRegion: 'Caribbean',
        regionCode: '019',
        subRegionCode: '419',
        intermediateRegionCode: '029',
        countryNameKey: 'countryNameKey_curacao',
        shortCountryNameKey: 'shortCountryNameKey_curacao',
        code2: 'CW',
        code3: 'CUW',
    },
    {
        phone: {
            mask: '##-###-###',
            dialCode: '+357',
            length: 8,
            fullMask: '+357-##-###-###',
            fullLength: 11,
        },
        currency: {
            name: 'Cyprus',
            code: 'EUR',
            units: 0,
        },
        name: 'Cyprus',
        countryCode: '196',
        iso3166: 'ISO 3166-2:CY',
        region: 'Asia',
        subRegion: 'Western Asia',
        intermediateRegion: '',
        regionCode: '142',
        subRegionCode: '145',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_cyprus',
        shortCountryNameKey: 'shortCountryNameKey_cyprus',
        code2: 'CY',
        code3: 'CYP',
    },
    {
        phone: {
            mask: '(###)###-###',
            dialCode: '+420',
            length: 9,
            fullMask: '+420(###)###-###',
            fullLength: 12,
        },
        currency: {
            name: 'Czech Koruna',
            code: 'CZK',
            units: 2,
        },
        name: 'Czechia',
        countryCode: '203',
        iso3166: 'ISO 3166-2:CZ',
        region: 'Europe',
        subRegion: 'Eastern Europe',
        intermediateRegion: '',
        regionCode: '150',
        subRegionCode: '151',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_czech_republic',
        shortCountryNameKey: 'shortCountryNameKey_czech_republic',
        code2: 'CZ',
        code3: 'CZE',
    },
    {
        phone: {
            mask: '####-#############',
            dialCode: '+850',
            length: 17,
            fullMask: '+850-####-#############',
            fullLength: 20,
        },
        currency: {
            name: 'North Korean Won',
            code: 'KPW',
            units: 2,
        },
        name: 'Korea (Democratic People\'s Republic of)',
        countryCode: '408',
        iso3166: 'ISO 3166-2:KP',
        region: 'Asia',
        subRegion: 'Eastern Asia',
        intermediateRegion: '',
        regionCode: '142',
        subRegionCode: '030',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_dpr_korea_(north)',
        shortCountryNameKey: 'shortCountryNameKey_dpr_korea_(north)',
        code2: 'KP',
        code3: 'PRK',
    },
    {
        phone: {
            mask: '(###)###-###',
            dialCode: '+243',
            length: 9,
            fullMask: '+243(###)###-###',
            fullLength: 12,
        },
        currency: {
            name: 'Congo (Democratic Republic of the)',
            code: 'USD',
            units: 0,
        },
        name: 'Congo (Democratic Republic of the)',
        countryCode: '180',
        iso3166: 'ISO 3166-2:CD',
        region: 'Africa',
        subRegion: 'Sub-Saharan Africa',
        intermediateRegion: 'Middle Africa',
        regionCode: '002',
        subRegionCode: '202',
        intermediateRegionCode: '017',
        countryNameKey: 'countryNameKey_dem._rep._congo',
        shortCountryNameKey: 'shortCountryNameKey_dem._rep._congo',
        code2: 'CD',
        code3: 'COD',
    },
    {
        phone: {
            mask: '##-##-##-##',
            dialCode: '+45',
            length: 8,
            fullMask: '+45-##-##-##-##',
            fullLength: 10,
        },
        currency: {
            name: 'Danish Krone',
            code: 'DKK',
            units: 2,
        },
        name: 'Denmark',
        countryCode: '208',
        iso3166: 'ISO 3166-2:DK',
        region: 'Europe',
        subRegion: 'Northern Europe',
        intermediateRegion: '',
        regionCode: '150',
        subRegionCode: '154',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_denmark',
        shortCountryNameKey: 'shortCountryNameKey_denmark',
        code2: 'DK',
        code3: 'DNK',
    },
    {
        phone: {
            mask: '###-####',
            dialCode: '+246',
            length: 7,
            fullMask: '+246-###-####',
            fullLength: 10,
        },
        currency: {
            name: 'British Indian Ocean Territory',
            code: 'USD',
            units: 0,
        },
        name: 'British Indian Ocean Territory',
        countryCode: '086',
        iso3166: 'ISO 3166-2:IO',
        region: 'Africa',
        subRegion: 'Sub-Saharan Africa',
        intermediateRegion: 'Eastern Africa',
        regionCode: '002',
        subRegionCode: '202',
        intermediateRegionCode: '014',
        countryNameKey: 'countryNameKey_diego_garcia',
        shortCountryNameKey: 'shortCountryNameKey_diego_garcia',
        code2: 'IO',
        code3: 'IOT',
    },
    {
        phone: {
            mask: '##-##-##-##',
            dialCode: '+253',
            length: 8,
            fullMask: '+253-##-##-##-##',
            fullLength: 11,
        },
        currency: {
            name: 'Djibouti Franc',
            code: 'DJF',
            units: 0,
        },
        name: 'Djibouti',
        countryCode: '262',
        iso3166: 'ISO 3166-2:DJ',
        region: 'Africa',
        subRegion: 'Sub-Saharan Africa',
        intermediateRegion: 'Eastern Africa',
        regionCode: '002',
        subRegionCode: '202',
        intermediateRegionCode: '014',
        countryNameKey: 'countryNameKey_djibouti',
        shortCountryNameKey: 'shortCountryNameKey_djibouti',
        code2: 'DJ',
        code3: 'DJI',
    },
    {
        phone: {
            mask: '###-####',
            dialCode: '+1767',
            length: 7,
            fullMask: '+1(767)###-####',
            fullLength: 11,
        },
        currency: {
            name: 'Dominica',
            code: 'USD',
            units: 0,
        },
        name: 'Dominica',
        countryCode: '212',
        iso3166: 'ISO 3166-2:DM',
        region: 'Americas',
        subRegion: 'Latin America and the Caribbean',
        intermediateRegion: 'Caribbean',
        regionCode: '019',
        subRegionCode: '419',
        intermediateRegionCode: '029',
        countryNameKey: 'countryNameKey_dominica',
        shortCountryNameKey: 'shortCountryNameKey_dominica',
        code2: 'DM',
        code3: 'DMA',
    },
    {
        phone: {
            mask: '###-####',
            dialCode: '+1849',
            length: 7,
            fullMask: '+1(849)###-####',
            fullLength: 11,
        },
        currency: {
            name: 'Dominican Peso',
            code: 'DOP',
            units: 2,
        },
        name: 'Dominican Republic',
        countryCode: '214',
        iso3166: 'ISO 3166-2:DO',
        region: 'Americas',
        subRegion: 'Latin America and the Caribbean',
        intermediateRegion: 'Caribbean',
        regionCode: '019',
        subRegionCode: '419',
        intermediateRegionCode: '029',
        countryNameKey: 'countryNameKey_dominican_republic',
        shortCountryNameKey: 'shortCountryNameKey_dominican_republic',
        code2: 'DO',
        code3: 'DOM',
    },
    {
        phone: {
            mask: '#-#####',
            dialCode: '+67078',
            length: 6,
            fullMask: '+670-78#-#####',
            fullLength: 11,
        },
        currency: {
            name: 'Timor-Leste',
            code: 'USD',
            units: 0,
        },
        name: 'Timor-Leste',
        countryCode: '626',
        iso3166: 'ISO 3166-2:TL',
        region: 'Asia',
        subRegion: 'South-eastern Asia',
        intermediateRegion: '',
        regionCode: '142',
        subRegionCode: '035',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_east_timor',
        shortCountryNameKey: 'shortCountryNameKey_east_timor',
        code2: 'TL',
        code3: 'TLS',
    },
    {
        phone: {
            mask: '#-###-####',
            dialCode: '+593',
            length: 8,
            fullMask: '+593-#-###-####',
            fullLength: 11,
        },
        currency: {
            name: 'Ecuador',
            code: 'USD',
            units: 0,
        },
        name: 'Ecuador',
        countryCode: '218',
        iso3166: 'ISO 3166-2:EC',
        region: 'Americas',
        subRegion: 'Latin America and the Caribbean',
        intermediateRegion: 'South America',
        regionCode: '019',
        subRegionCode: '419',
        intermediateRegionCode: '005',
        countryNameKey: 'countryNameKey_ecuador',
        shortCountryNameKey: 'shortCountryNameKey_ecuador',
        code2: 'EC',
        code3: 'ECU',
    },
    {
        phone: {
            mask: '(###)###-####',
            dialCode: '+20',
            length: 10,
            fullMask: '+20(###)###-####',
            fullLength: 12,
        },
        currency: {
            name: 'Egyptian Pound',
            code: 'EGP',
            units: 2,
        },
        name: 'Egypt',
        countryCode: '818',
        iso3166: 'ISO 3166-2:EG',
        region: 'Africa',
        subRegion: 'Northern Africa',
        intermediateRegion: '',
        regionCode: '002',
        subRegionCode: '015',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_egypt',
        shortCountryNameKey: 'shortCountryNameKey_egypt',
        code2: 'EG',
        code3: 'EGY',
    },
    {
        phone: {
            mask: '##-##-####',
            dialCode: '+503',
            length: 8,
            fullMask: '+503-##-##-####',
            fullLength: 11,
        },
        currency: {
            name: 'El Salvador Colon',
            code: 'SVC',
            units: 2,
        },
        name: 'El Salvador',
        countryCode: '222',
        iso3166: 'ISO 3166-2:SV',
        region: 'Americas',
        subRegion: 'Latin America and the Caribbean',
        intermediateRegion: 'Central America',
        regionCode: '019',
        subRegionCode: '419',
        intermediateRegionCode: '013',
        countryNameKey: 'countryNameKey_el_salvador',
        shortCountryNameKey: 'shortCountryNameKey_el_salvador',
        code2: 'SV',
        code3: 'SLV',
    },
    {
        phone: {
            mask: '##-###-####',
            dialCode: '+240',
            length: 9,
            fullMask: '+240-##-###-####',
            fullLength: 12,
        },
        currency: {
            name: 'Equatorial Guinea',
            code: 'USD',
            units: 0,
        },
        name: 'Equatorial Guinea',
        countryCode: '226',
        iso3166: 'ISO 3166-2:GQ',
        region: 'Africa',
        subRegion: 'Sub-Saharan Africa',
        intermediateRegion: 'Middle Africa',
        regionCode: '002',
        subRegionCode: '202',
        intermediateRegionCode: '017',
        countryNameKey: 'countryNameKey_equatorial_guinea',
        shortCountryNameKey: 'shortCountryNameKey_equatorial_guinea',
        code2: 'GQ',
        code3: 'GNQ',
    },
    {
        phone: {
            mask: '#-###-###',
            dialCode: '+291',
            length: 7,
            fullMask: '+291-#-###-###',
            fullLength: 10,
        },
        currency: {
            name: 'Nakfa',
            code: 'ERN',
            units: 2,
        },
        name: 'Eritrea',
        countryCode: '232',
        iso3166: 'ISO 3166-2:ER',
        region: 'Africa',
        subRegion: 'Sub-Saharan Africa',
        intermediateRegion: 'Eastern Africa',
        regionCode: '002',
        subRegionCode: '202',
        intermediateRegionCode: '014',
        countryNameKey: 'countryNameKey_eritrea',
        shortCountryNameKey: 'shortCountryNameKey_eritrea',
        code2: 'ER',
        code3: 'ERI',
    },
    {
        phone: {
            mask: '###-####',
            dialCode: '+372',
            length: 7,
            fullMask: '+372-###-####',
            fullLength: 10,
        },
        currency: {
            name: 'Estonia',
            code: 'EUR',
            units: 0,
        },
        name: 'Estonia',
        countryCode: '233',
        iso3166: 'ISO 3166-2:EE',
        region: 'Europe',
        subRegion: 'Northern Europe',
        intermediateRegion: '',
        regionCode: '150',
        subRegionCode: '154',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_estonia',
        shortCountryNameKey: 'shortCountryNameKey_estonia',
        code2: 'EE',
        code3: 'EST',
    },
    {
        phone: {
            mask: '##-###-####',
            dialCode: '+251',
            length: 9,
            fullMask: '+251-##-###-####',
            fullLength: 12,
        },
        currency: {
            name: 'Ethiopia',
            code: 'USD',
            units: 0,
        },
        name: 'Ethiopia',
        countryCode: '231',
        iso3166: 'ISO 3166-2:ET',
        region: 'Africa',
        subRegion: 'Sub-Saharan Africa',
        intermediateRegion: 'Eastern Africa',
        regionCode: '002',
        subRegionCode: '202',
        intermediateRegionCode: '014',
        countryNameKey: 'countryNameKey_ethiopia',
        shortCountryNameKey: 'shortCountryNameKey_ethiopia',
        code2: 'ET',
        code3: 'ETH',
    },
    {
        phone: {
            mask: '###-####',
            dialCode: '+691',
            length: 7,
            fullMask: '+691-###-####',
            fullLength: 10,
        },
        currency: {
            name: 'Micronesia (Federated States of)',
            code: 'USD',
            units: 0,
        },
        name: 'Micronesia (Federated States of)',
        countryCode: '583',
        iso3166: 'ISO 3166-2:FM',
        region: 'Oceania',
        subRegion: 'Micronesia',
        intermediateRegion: '',
        regionCode: '009',
        subRegionCode: '057',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_f.s._micronesia',
        shortCountryNameKey: 'shortCountryNameKey_f.s._micronesia',
        code2: 'FM',
        code3: 'FSM',
    },
    {
        phone: {
            mask: '#####',
            dialCode: '+500',
            length: 5,
            fullMask: '+500-#####',
            fullLength: 8,
        },
        currency: {
            name: 'Falkland Islands Pound',
            code: 'FKP',
            units: 2,
        },
        name: 'Falkland Islands (Malvinas)',
        countryCode: '238',
        iso3166: 'ISO 3166-2:FK',
        region: 'Americas',
        subRegion: 'Latin America and the Caribbean',
        intermediateRegion: 'South America',
        regionCode: '019',
        subRegionCode: '419',
        intermediateRegionCode: '005',
        countryNameKey: 'countryNameKey_falkland_islands',
        shortCountryNameKey: 'shortCountryNameKey_falkland_islands',
        code2: 'FK',
        code3: 'FLK',
    },
    {
        phone: {
            mask: '###-###',
            dialCode: '+298',
            length: 6,
            fullMask: '+298-###-###',
            fullLength: 9,
        },
        currency: {
            name: 'Faroe Islands',
            code: 'USD',
            units: 0,
        },
        name: 'Faroe Islands',
        countryCode: '234',
        iso3166: 'ISO 3166-2:FO',
        region: 'Europe',
        subRegion: 'Northern Europe',
        intermediateRegion: '',
        regionCode: '150',
        subRegionCode: '154',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_faroe_islands',
        shortCountryNameKey: 'shortCountryNameKey_faroe_islands',
        code2: 'FO',
        code3: 'FRO',
    },
    {
        phone: {
            mask: '##-#####',
            dialCode: '+679',
            length: 7,
            fullMask: '+679-##-#####',
            fullLength: 10,
        },
        currency: {
            name: 'Fiji Dollar',
            code: 'FJD',
            units: 2,
        },
        name: 'Fiji',
        countryCode: '242',
        iso3166: 'ISO 3166-2:FJ',
        region: 'Oceania',
        subRegion: 'Melanesia',
        intermediateRegion: '',
        regionCode: '009',
        subRegionCode: '054',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_fiji',
        shortCountryNameKey: 'shortCountryNameKey_fiji',
        code2: 'FJ',
        code3: 'FJI',
    },
    {
        phone: {
            mask: '(###)###-##-##',
            dialCode: '+358',
            length: 10,
            fullMask: '+358(###)###-##-##',
            fullLength: 13,
        },
        currency: {
            name: 'Finland',
            code: 'USD',
            units: 0,
        },
        name: 'Finland',
        countryCode: '246',
        iso3166: 'ISO 3166-2:FI',
        region: 'Europe',
        subRegion: 'Northern Europe',
        intermediateRegion: '',
        regionCode: '150',
        subRegionCode: '154',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_finland',
        shortCountryNameKey: 'shortCountryNameKey_finland',
        code2: 'FI',
        code3: 'FIN',
    },
    {
        phone: {
            mask: '(###)###-###',
            dialCode: '+33',
            length: 9,
            fullMask: '+33(###)###-###',
            fullLength: 11,
        },
        currency: {
            name: 'France',
            code: 'EUR',
            units: 0,
        },
        name: 'France',
        countryCode: '250',
        iso3166: 'ISO 3166-2:FR',
        region: 'Europe',
        subRegion: 'Western Europe',
        intermediateRegion: '',
        regionCode: '150',
        subRegionCode: '155',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_france',
        shortCountryNameKey: 'shortCountryNameKey_france',
        code2: 'FR',
        code3: 'FRA',
    },
    {
        phone: {
            mask: '##-##-##',
            dialCode: '+689',
            length: 6,
            fullMask: '+689-##-##-##',
            fullLength: 9,
        },
        currency: {
            name: 'French Polynesia',
            code: 'USD',
            units: 0,
        },
        name: 'French Polynesia',
        countryCode: '258',
        iso3166: 'ISO 3166-2:PF',
        region: 'Oceania',
        subRegion: 'Polynesia',
        intermediateRegion: '',
        regionCode: '009',
        subRegionCode: '061',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_french_polynesia',
        shortCountryNameKey: 'shortCountryNameKey_french_polynesia',
        code2: 'PF',
        code3: 'PYF',
    },
    {
        phone: {
            mask: '#-##-##-##',
            dialCode: '+241',
            length: 7,
            fullMask: '+241-#-##-##-##',
            fullLength: 10,
        },
        currency: {
            name: 'Gabon',
            code: 'USD',
            units: 0,
        },
        name: 'Gabon',
        countryCode: '266',
        iso3166: 'ISO 3166-2:GA',
        region: 'Africa',
        subRegion: 'Sub-Saharan Africa',
        intermediateRegion: 'Middle Africa',
        regionCode: '002',
        subRegionCode: '202',
        intermediateRegionCode: '017',
        countryNameKey: 'countryNameKey_gabon',
        shortCountryNameKey: 'shortCountryNameKey_gabon',
        code2: 'GA',
        code3: 'GAB',
    },
    {
        phone: {
            mask: '(###)##-##',
            dialCode: '+220',
            length: 7,
            fullMask: '+220(###)##-##',
            fullLength: 10,
        },
        currency: {
            name: 'Dalasi',
            code: 'GMD',
            units: 2,
        },
        name: 'Gambia',
        countryCode: '270',
        iso3166: 'ISO 3166-2:GM',
        region: 'Africa',
        subRegion: 'Sub-Saharan Africa',
        intermediateRegion: 'Western Africa',
        regionCode: '002',
        subRegionCode: '202',
        intermediateRegionCode: '011',
        countryNameKey: 'countryNameKey_gambia',
        shortCountryNameKey: 'shortCountryNameKey_gambia',
        code2: 'GM',
        code3: 'GMB',
    },
    {
        phone: {
            mask: '(###)##-###',
            dialCode: '+49',
            length: 8,
            fullMask: '+49(###)##-###',
            fullLength: 10,
        },
        currency: {
            name: 'Germany',
            code: 'EUR',
            units: 0,
        },
        name: 'Germany',
        countryCode: '276',
        iso3166: 'ISO 3166-2:DE',
        region: 'Europe',
        subRegion: 'Western Europe',
        intermediateRegion: '',
        regionCode: '150',
        subRegionCode: '155',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_germany',
        shortCountryNameKey: 'shortCountryNameKey_germany',
        code2: 'DE',
        code3: 'DEU',
    },
    {
        phone: {
            mask: '(###)###-###',
            dialCode: '+233',
            length: 9,
            fullMask: '+233(###)###-###',
            fullLength: 12,
        },
        currency: {
            name: 'Ghana',
            code: 'USD',
            units: 0,
        },
        name: 'Ghana',
        countryCode: '288',
        iso3166: 'ISO 3166-2:GH',
        region: 'Africa',
        subRegion: 'Sub-Saharan Africa',
        intermediateRegion: 'Western Africa',
        regionCode: '002',
        subRegionCode: '202',
        intermediateRegionCode: '011',
        countryNameKey: 'countryNameKey_ghana',
        shortCountryNameKey: 'shortCountryNameKey_ghana',
        code2: 'GH',
        code3: 'GHA',
    },
    {
        phone: {
            mask: '###-#####',
            dialCode: '+350',
            length: 8,
            fullMask: '+350-###-#####',
            fullLength: 11,
        },
        currency: {
            name: 'Gibraltar Pound',
            code: 'GIP',
            units: 2,
        },
        name: 'Gibraltar',
        countryCode: '292',
        iso3166: 'ISO 3166-2:GI',
        region: 'Europe',
        subRegion: 'Southern Europe',
        intermediateRegion: '',
        regionCode: '150',
        subRegionCode: '039',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_gibraltar',
        shortCountryNameKey: 'shortCountryNameKey_gibraltar',
        code2: 'GI',
        code3: 'GIB',
    },
    {
        phone: {
            mask: '(###)###-####',
            dialCode: '+30',
            length: 10,
            fullMask: '+30(###)###-####',
            fullLength: 12,
        },
        currency: {
            name: 'Greece',
            code: 'EUR',
            units: 0,
        },
        name: 'Greece',
        countryCode: '300',
        iso3166: 'ISO 3166-2:GR',
        region: 'Europe',
        subRegion: 'Southern Europe',
        intermediateRegion: '',
        regionCode: '150',
        subRegionCode: '039',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_greece',
        shortCountryNameKey: 'shortCountryNameKey_greece',
        code2: 'GR',
        code3: 'GRC',
    },
    {
        phone: {
            mask: '##-##-##',
            dialCode: '+299',
            length: 6,
            fullMask: '+299-##-##-##',
            fullLength: 9,
        },
        currency: {
            name: 'Greenland',
            code: 'USD',
            units: 0,
        },
        name: 'Greenland',
        countryCode: '304',
        iso3166: 'ISO 3166-2:GL',
        region: 'Americas',
        subRegion: 'Northern America',
        intermediateRegion: '',
        regionCode: '019',
        subRegionCode: '021',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_greenland',
        shortCountryNameKey: 'shortCountryNameKey_greenland',
        code2: 'GL',
        code3: 'GRL',
    },
    {
        phone: {
            mask: '###-####',
            dialCode: '+1473',
            length: 7,
            fullMask: '+1(473)###-####',
            fullLength: 11,
        },
        currency: {
            name: 'Grenada',
            code: 'USD',
            units: 0,
        },
        name: 'Grenada',
        countryCode: '308',
        iso3166: 'ISO 3166-2:GD',
        region: 'Americas',
        subRegion: 'Latin America and the Caribbean',
        intermediateRegion: 'Caribbean',
        regionCode: '019',
        subRegionCode: '419',
        intermediateRegionCode: '029',
        countryNameKey: 'countryNameKey_grenada',
        shortCountryNameKey: 'shortCountryNameKey_grenada',
        code2: 'GD',
        code3: 'GRD',
    },
    {
        phone: {
            mask: '###-####',
            dialCode: '+1671',
            length: 7,
            fullMask: '+1(671)###-####',
            fullLength: 11,
        },
        currency: {
            name: 'Guam',
            code: 'USD',
            units: 0,
        },
        name: 'Guam',
        countryCode: '316',
        iso3166: 'ISO 3166-2:GU',
        region: 'Oceania',
        subRegion: 'Micronesia',
        intermediateRegion: '',
        regionCode: '009',
        subRegionCode: '057',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_guam',
        shortCountryNameKey: 'shortCountryNameKey_guam',
        code2: 'GU',
        code3: 'GUM',
    },
    {
        phone: {
            mask: '#-###-####',
            dialCode: '+502',
            length: 8,
            fullMask: '+502-#-###-####',
            fullLength: 11,
        },
        currency: {
            name: 'Quetzal',
            code: 'GTQ',
            units: 2,
        },
        name: 'Guatemala',
        countryCode: '320',
        iso3166: 'ISO 3166-2:GT',
        region: 'Americas',
        subRegion: 'Latin America and the Caribbean',
        intermediateRegion: 'Central America',
        regionCode: '019',
        subRegionCode: '419',
        intermediateRegionCode: '013',
        countryNameKey: 'countryNameKey_guatemala',
        shortCountryNameKey: 'shortCountryNameKey_guatemala',
        code2: 'GT',
        code3: 'GTM',
    },
    {
        phone: {
            mask: '#####-####',
            dialCode: '+594',
            length: 9,
            fullMask: '+594-#####-####',
            fullLength: 12,
        },
        currency: {
            name: 'French Guiana',
            code: 'USD',
            units: 0,
        },
        name: 'French Guiana',
        countryCode: '254',
        iso3166: 'ISO 3166-2:GF',
        region: 'Americas',
        subRegion: 'Latin America and the Caribbean',
        intermediateRegion: 'South America',
        regionCode: '019',
        subRegionCode: '419',
        intermediateRegionCode: '005',
        countryNameKey: 'countryNameKey_guiana_(french)',
        shortCountryNameKey: 'shortCountryNameKey_guiana_(french)',
        code2: 'GF',
        code3: 'GUF',
    },
    {
        phone: {
            mask: '##-###-###',
            dialCode: '+224',
            length: 8,
            fullMask: '+224-##-###-###',
            fullLength: 11,
        },
        currency: {
            name: 'Guinean Franc',
            code: 'GNF',
            units: 0,
        },
        name: 'Guinea',
        countryCode: '324',
        iso3166: 'ISO 3166-2:GN',
        region: 'Africa',
        subRegion: 'Sub-Saharan Africa',
        intermediateRegion: 'Western Africa',
        regionCode: '002',
        subRegionCode: '202',
        intermediateRegionCode: '011',
        countryNameKey: 'countryNameKey_guinea',
        shortCountryNameKey: 'shortCountryNameKey_guinea',
        code2: 'GN',
        code3: 'GIN',
    },
    {
        phone: {
            mask: '#-######',
            dialCode: '+245',
            length: 7,
            fullMask: '+245-#-######',
            fullLength: 10,
        },
        currency: {
            name: 'Guinea-Bissau',
            code: 'USD',
            units: 0,
        },
        name: 'Guinea-Bissau',
        countryCode: '624',
        iso3166: 'ISO 3166-2:GW',
        region: 'Africa',
        subRegion: 'Sub-Saharan Africa',
        intermediateRegion: 'Western Africa',
        regionCode: '002',
        subRegionCode: '202',
        intermediateRegionCode: '011',
        countryNameKey: 'countryNameKey_guinea-bissau',
        shortCountryNameKey: 'shortCountryNameKey_guinea-bissau',
        code2: 'GW',
        code3: 'GNB',
    },
    {
        phone: {
            mask: '###-####',
            dialCode: '+592',
            length: 7,
            fullMask: '+592-###-####',
            fullLength: 10,
        },
        currency: {
            name: 'Guyana Dollar',
            code: 'GYD',
            units: 2,
        },
        name: 'Guyana',
        countryCode: '328',
        iso3166: 'ISO 3166-2:GY',
        region: 'Americas',
        subRegion: 'Latin America and the Caribbean',
        intermediateRegion: 'South America',
        regionCode: '019',
        subRegionCode: '419',
        intermediateRegionCode: '005',
        countryNameKey: 'countryNameKey_guyana',
        shortCountryNameKey: 'shortCountryNameKey_guyana',
        code2: 'GY',
        code3: 'GUY',
    },
    {
        phone: {
            mask: '##-##-####',
            dialCode: '+509',
            length: 8,
            fullMask: '+509-##-##-####',
            fullLength: 11,
        },
        currency: {
            name: 'Gourde',
            code: 'HTG',
            units: 2,
        },
        name: 'Haiti',
        countryCode: '332',
        iso3166: 'ISO 3166-2:HT',
        region: 'Americas',
        subRegion: 'Latin America and the Caribbean',
        intermediateRegion: 'Caribbean',
        regionCode: '019',
        subRegionCode: '419',
        intermediateRegionCode: '029',
        countryNameKey: 'countryNameKey_haiti',
        shortCountryNameKey: 'shortCountryNameKey_haiti',
        code2: 'HT',
        code3: 'HTI',
    },
    {
        phone: {
            mask: '####-####',
            dialCode: '+504',
            length: 8,
            fullMask: '+504-####-####',
            fullLength: 11,
        },
        currency: {
            name: 'Lempira',
            code: 'HNL',
            units: 2,
        },
        name: 'Honduras',
        countryCode: '340',
        iso3166: 'ISO 3166-2:HN',
        region: 'Americas',
        subRegion: 'Latin America and the Caribbean',
        intermediateRegion: 'Central America',
        regionCode: '019',
        subRegionCode: '419',
        intermediateRegionCode: '013',
        countryNameKey: 'countryNameKey_honduras',
        shortCountryNameKey: 'shortCountryNameKey_honduras',
        code2: 'HN',
        code3: 'HND',
    },
    {
        phone: {
            mask: '####-####',
            dialCode: '+852',
            length: 8,
            fullMask: '+852-####-####',
            fullLength: 11,
        },
        currency: {
            name: 'Hong Kong Dollar',
            code: 'HKD',
            units: 2,
        },
        name: 'Hong Kong',
        countryCode: '344',
        iso3166: 'ISO 3166-2:HK',
        region: 'Asia',
        subRegion: 'Eastern Asia',
        intermediateRegion: '',
        regionCode: '142',
        subRegionCode: '030',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_hong_kong',
        shortCountryNameKey: 'shortCountryNameKey_hong_kong',
        code2: 'HK',
        code3: 'HKG',
    },
    {
        phone: {
            mask: '(###)###-###',
            dialCode: '+36',
            length: 9,
            fullMask: '+36(###)###-###',
            fullLength: 11,
        },
        currency: {
            name: 'Forint',
            code: 'HUF',
            units: 2,
        },
        name: 'Hungary',
        countryCode: '348',
        iso3166: 'ISO 3166-2:HU',
        region: 'Europe',
        subRegion: 'Eastern Europe',
        intermediateRegion: '',
        regionCode: '150',
        subRegionCode: '151',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_hungary',
        shortCountryNameKey: 'shortCountryNameKey_hungary',
        code2: 'HU',
        code3: 'HUN',
    },
    {
        phone: {
            mask: '###-####',
            dialCode: '+354',
            length: 7,
            fullMask: '+354-###-####',
            fullLength: 10,
        },
        currency: {
            name: 'Iceland Krona',
            code: 'ISK',
            units: 0,
        },
        name: 'Iceland',
        countryCode: '352',
        iso3166: 'ISO 3166-2:IS',
        region: 'Europe',
        subRegion: 'Northern Europe',
        intermediateRegion: '',
        regionCode: '150',
        subRegionCode: '154',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_iceland',
        shortCountryNameKey: 'shortCountryNameKey_iceland',
        code2: 'IS',
        code3: 'ISL',
    },
    {
        phone: {
            mask: '(####)###-###',
            dialCode: '+91',
            length: 10,
            fullMask: '+91(####)###-###',
            fullLength: 12,
        },
        currency: {
            name: 'Indian Rupee',
            code: 'INR',
            units: 2,
        },
        name: 'India',
        countryCode: '356',
        iso3166: 'ISO 3166-2:IN',
        region: 'Asia',
        subRegion: 'Southern Asia',
        intermediateRegion: '',
        regionCode: '142',
        subRegionCode: '034',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_india',
        shortCountryNameKey: 'shortCountryNameKey_india',
        code2: 'IN',
        code3: 'IND',
    },
    {
        phone: {
            mask: '##-###-###',
            dialCode: '+62',
            length: 8,
            fullMask: '+62-##-###-###',
            fullLength: 10,
        },
        currency: {
            name: 'Rupiah',
            code: 'IDR',
            units: 2,
        },
        name: 'Indonesia',
        countryCode: '360',
        iso3166: 'ISO 3166-2:ID',
        region: 'Asia',
        subRegion: 'South-eastern Asia',
        intermediateRegion: '',
        regionCode: '142',
        subRegionCode: '035',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_indonesia',
        shortCountryNameKey: 'shortCountryNameKey_indonesia',
        code2: 'ID',
        code3: 'IDN',
    },
    {
        phone: {
            mask: '(###)###-####',
            dialCode: '+98',
            length: 10,
            fullMask: '+98(###)###-####',
            fullLength: 12,
        },
        currency: {
            name: 'Iranian Rial',
            code: 'IRR',
            units: 2,
        },
        name: 'Iran (Islamic Republic of)',
        countryCode: '364',
        iso3166: 'ISO 3166-2:IR',
        region: 'Asia',
        subRegion: 'Southern Asia',
        intermediateRegion: '',
        regionCode: '142',
        subRegionCode: '034',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_iran',
        shortCountryNameKey: 'shortCountryNameKey_iran',
        code2: 'IR',
        code3: 'IRN',
    },
    {
        phone: {
            mask: '(###)###-####',
            dialCode: '+964',
            length: 10,
            fullMask: '+964(###)###-####',
            fullLength: 13,
        },
        currency: {
            name: 'Iraqi Dinar',
            code: 'IQD',
            units: 3,
        },
        name: 'Iraq',
        countryCode: '368',
        iso3166: 'ISO 3166-2:IQ',
        region: 'Asia',
        subRegion: 'Western Asia',
        intermediateRegion: '',
        regionCode: '142',
        subRegionCode: '145',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_iraq',
        shortCountryNameKey: 'shortCountryNameKey_iraq',
        code2: 'IQ',
        code3: 'IRQ',
    },
    {
        phone: {
            mask: '(###)###-###',
            dialCode: '+353',
            length: 9,
            fullMask: '+353(###)###-###',
            fullLength: 12,
        },
        currency: {
            name: 'Ireland',
            code: 'EUR',
            units: 0,
        },
        name: 'Ireland',
        countryCode: '372',
        iso3166: 'ISO 3166-2:IE',
        region: 'Europe',
        subRegion: 'Northern Europe',
        intermediateRegion: '',
        regionCode: '150',
        subRegionCode: '154',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_ireland',
        shortCountryNameKey: 'shortCountryNameKey_ireland',
        code2: 'IE',
        code3: 'IRL',
    },
    {
        phone: {
            mask: '#-###-####',
            dialCode: '+972',
            length: 8,
            fullMask: '+972-#-###-####',
            fullLength: 11,
        },
        currency: {
            name: 'New Israeli Sheqel',
            code: 'ILS',
            units: 2,
        },
        name: 'Israel',
        countryCode: '376',
        iso3166: 'ISO 3166-2:IL',
        region: 'Asia',
        subRegion: 'Western Asia',
        intermediateRegion: '',
        regionCode: '142',
        subRegionCode: '145',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_israel',
        shortCountryNameKey: 'shortCountryNameKey_israel',
        code2: 'IL',
        code3: 'ISR',
    },
    {
        phone: {
            mask: '(###)####-###',
            dialCode: '+39',
            length: 10,
            fullMask: '+39(###)####-###',
            fullLength: 12,
        },
        currency: {
            name: 'Italy',
            code: 'EUR',
            units: 0,
        },
        name: 'Italy',
        countryCode: '380',
        iso3166: 'ISO 3166-2:IT',
        region: 'Europe',
        subRegion: 'Southern Europe',
        intermediateRegion: '',
        regionCode: '150',
        subRegionCode: '039',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_italy',
        shortCountryNameKey: 'shortCountryNameKey_italy',
        code2: 'IT',
        code3: 'ITA',
    },
    {
        phone: {
            mask: '###-####',
            dialCode: '+1876',
            length: 7,
            fullMask: '+1(876)###-####',
            fullLength: 11,
        },
        currency: {
            name: 'Jamaican Dollar',
            code: 'JMD',
            units: 2,
        },
        name: 'Jamaica',
        countryCode: '388',
        iso3166: 'ISO 3166-2:JM',
        region: 'Americas',
        subRegion: 'Latin America and the Caribbean',
        intermediateRegion: 'Caribbean',
        regionCode: '019',
        subRegionCode: '419',
        intermediateRegionCode: '029',
        countryNameKey: 'countryNameKey_jamaica',
        shortCountryNameKey: 'shortCountryNameKey_jamaica',
        code2: 'JM',
        code3: 'JAM',
    },
    {
        phone: {
            mask: '###-####-####',
            dialCode: '+81',
            length: 11,
            fullMask: '+81-###-####-####',
            fullLength: 13,
        },
        currency: {
            name: 'Yen',
            code: 'JPY',
            units: 0,
        },
        name: 'Japan',
        countryCode: '392',
        iso3166: 'ISO 3166-2:JP',
        region: 'Asia',
        subRegion: 'Eastern Asia',
        intermediateRegion: '',
        regionCode: '142',
        subRegionCode: '030',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_japan',
        shortCountryNameKey: 'shortCountryNameKey_japan',
        code2: 'JP',
        code3: 'JPN',
    },
    {
        phone: {
            mask: '#-####-####',
            dialCode: '+962',
            length: 9,
            fullMask: '+962-#-####-####',
            fullLength: 12,
        },
        currency: {
            name: 'Jordanian Dinar',
            code: 'JOD',
            units: 3,
        },
        name: 'Jordan',
        countryCode: '400',
        iso3166: 'ISO 3166-2:JO',
        region: 'Asia',
        subRegion: 'Western Asia',
        intermediateRegion: '',
        regionCode: '142',
        subRegionCode: '145',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_jordan',
        shortCountryNameKey: 'shortCountryNameKey_jordan',
        code2: 'JO',
        code3: 'JOR',
    },
    {
        phone: {
            mask: '##)###-##-##',
            dialCode: '+77',
            length: 9,
            fullMask: '+7(7##)###-##-##',
            fullLength: 11,
        },
        currency: {
            name: 'Tenge',
            code: 'KZT',
            units: 2,
        },
        name: 'Kazakhstan',
        countryCode: '398',
        iso3166: 'ISO 3166-2:KZ',
        region: 'Asia',
        subRegion: 'Central Asia',
        intermediateRegion: '',
        regionCode: '142',
        subRegionCode: '143',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_kazakhstan',
        shortCountryNameKey: 'shortCountryNameKey_kazakhstan',
        code2: 'KZ',
        code3: 'KAZ',
    },
    {
        phone: {
            mask: '###-######',
            dialCode: '+254',
            length: 9,
            fullMask: '+254-###-######',
            fullLength: 12,
        },
        currency: {
            name: 'Kenyan Shilling',
            code: 'KES',
            units: 2,
        },
        name: 'Kenya',
        countryCode: '404',
        iso3166: 'ISO 3166-2:KE',
        region: 'Africa',
        subRegion: 'Sub-Saharan Africa',
        intermediateRegion: 'Eastern Africa',
        regionCode: '002',
        subRegionCode: '202',
        intermediateRegionCode: '014',
        countryNameKey: 'countryNameKey_kenya',
        shortCountryNameKey: 'shortCountryNameKey_kenya',
        code2: 'KE',
        code3: 'KEN',
    },
    {
        phone: {
            mask: '##-###',
            dialCode: '+686',
            length: 5,
            fullMask: '+686-##-###',
            fullLength: 8,
        },
        currency: {
            name: 'Kiribati',
            code: 'USD',
            units: 0,
        },
        name: 'Kiribati',
        countryCode: '296',
        iso3166: 'ISO 3166-2:KI',
        region: 'Oceania',
        subRegion: 'Micronesia',
        intermediateRegion: '',
        regionCode: '009',
        subRegionCode: '057',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_kiribati',
        shortCountryNameKey: 'shortCountryNameKey_kiribati',
        code2: 'KI',
        code3: 'KIR',
    },
    {
        phone: {
            mask: '##-###-####',
            dialCode: '+82',
            length: 9,
            fullMask: '+82-##-###-####',
            fullLength: 11,
        },
        currency: {
            name: 'Won',
            code: 'KRW',
            units: 0,
        },
        name: 'Korea (Republic of)',
        countryCode: '410',
        iso3166: 'ISO 3166-2:KR',
        region: 'Asia',
        subRegion: 'Eastern Asia',
        intermediateRegion: '',
        regionCode: '142',
        subRegionCode: '030',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_korea_(south)',
        shortCountryNameKey: 'shortCountryNameKey_korea_(south)',
        code2: 'KR',
        code3: 'KOR',
    },
    {
        phone: {
            mask: '####-####',
            dialCode: '+965',
            length: 8,
            fullMask: '+965-####-####',
            fullLength: 11,
        },
        currency: {
            name: 'Kuwaiti Dinar',
            code: 'KWD',
            units: 3,
        },
        name: 'Kuwait',
        countryCode: '414',
        iso3166: 'ISO 3166-2:KW',
        region: 'Asia',
        subRegion: 'Western Asia',
        intermediateRegion: '',
        regionCode: '142',
        subRegionCode: '145',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_kuwait',
        shortCountryNameKey: 'shortCountryNameKey_kuwait',
        code2: 'KW',
        code3: 'KWT',
    },
    {
        phone: {
            mask: '(###)###-###',
            dialCode: '+996',
            length: 9,
            fullMask: '+996(###)###-###',
            fullLength: 12,
        },
        currency: {
            name: 'Som',
            code: 'KGS',
            units: 2,
        },
        name: 'Kyrgyzstan',
        countryCode: '417',
        iso3166: 'ISO 3166-2:KG',
        region: 'Asia',
        subRegion: 'Central Asia',
        intermediateRegion: '',
        regionCode: '142',
        subRegionCode: '143',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_kyrgyzstan',
        shortCountryNameKey: 'shortCountryNameKey_kyrgyzstan',
        code2: 'KG',
        code3: 'KGZ',
    },
    {
        phone: {
            mask: '##-###-###',
            dialCode: '+856',
            length: 8,
            fullMask: '+856-##-###-###',
            fullLength: 11,
        },
        currency: {
            name: 'Lao Kip',
            code: 'LAK',
            units: 2,
        },
        name: 'Lao People\'s Democratic Republic',
        countryCode: '418',
        iso3166: 'ISO 3166-2:LA',
        region: 'Asia',
        subRegion: 'South-eastern Asia',
        intermediateRegion: '',
        regionCode: '142',
        subRegionCode: '035',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_laos',
        shortCountryNameKey: 'shortCountryNameKey_laos',
        code2: 'LA',
        code3: 'LAO',
    },
    {
        phone: {
            mask: '##-###-###',
            dialCode: '+371',
            length: 8,
            fullMask: '+371-##-###-###',
            fullLength: 11,
        },
        currency: {
            name: 'Latvia',
            code: 'LVL',
            units: 0,
        },
        name: 'Latvia',
        countryCode: '428',
        iso3166: 'ISO 3166-2:LV',
        region: 'Europe',
        subRegion: 'Northern Europe',
        intermediateRegion: '',
        regionCode: '150',
        subRegionCode: '154',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_latvia',
        shortCountryNameKey: 'shortCountryNameKey_latvia',
        code2: 'LV',
        code3: 'LVA',
    },
    {
        phone: {
            mask: '#-###-###',
            dialCode: '+961',
            length: 7,
            fullMask: '+961-#-###-###',
            fullLength: 10,
        },
        currency: {
            name: 'Lebanese Pound',
            code: 'LBP',
            units: 2,
        },
        name: 'Lebanon',
        countryCode: '422',
        iso3166: 'ISO 3166-2:LB',
        region: 'Asia',
        subRegion: 'Western Asia',
        intermediateRegion: '',
        regionCode: '142',
        subRegionCode: '145',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_lebanon',
        shortCountryNameKey: 'shortCountryNameKey_lebanon',
        code2: 'LB',
        code3: 'LBN',
    },
    {
        phone: {
            mask: '#-###-####',
            dialCode: '+266',
            length: 8,
            fullMask: '+266-#-###-####',
            fullLength: 11,
        },
        currency: {
            name: 'Loti',
            code: 'LSL',
            units: 2,
        },
        name: 'Lesotho',
        countryCode: '426',
        iso3166: 'ISO 3166-2:LS',
        region: 'Africa',
        subRegion: 'Sub-Saharan Africa',
        intermediateRegion: 'Southern Africa',
        regionCode: '002',
        subRegionCode: '202',
        intermediateRegionCode: '018',
        countryNameKey: 'countryNameKey_lesotho',
        shortCountryNameKey: 'shortCountryNameKey_lesotho',
        code2: 'LS',
        code3: 'LSO',
    },
    {
        phone: {
            mask: '##-###-###',
            dialCode: '+231',
            length: 8,
            fullMask: '+231-##-###-###',
            fullLength: 11,
        },
        currency: {
            name: 'Liberian Dollar',
            code: 'LRD',
            units: 2,
        },
        name: 'Liberia',
        countryCode: '430',
        iso3166: 'ISO 3166-2:LR',
        region: 'Africa',
        subRegion: 'Sub-Saharan Africa',
        intermediateRegion: 'Western Africa',
        regionCode: '002',
        subRegionCode: '202',
        intermediateRegionCode: '011',
        countryNameKey: 'countryNameKey_liberia',
        shortCountryNameKey: 'shortCountryNameKey_liberia',
        code2: 'LR',
        code3: 'LBR',
    },
    {
        phone: {
            mask: '##-###-###',
            dialCode: '+218',
            length: 8,
            fullMask: '+218-##-###-###',
            fullLength: 11,
        },
        currency: {
            name: 'Libyan Dinar',
            code: 'LYD',
            units: 3,
        },
        name: 'Libya',
        countryCode: '434',
        iso3166: 'ISO 3166-2:LY',
        region: 'Africa',
        subRegion: 'Northern Africa',
        intermediateRegion: '',
        regionCode: '002',
        subRegionCode: '015',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_libya',
        shortCountryNameKey: 'shortCountryNameKey_libya',
        code2: 'LY',
        code3: 'LBY',
    },
    {
        phone: {
            mask: '(###)###-####',
            dialCode: '+423',
            length: 10,
            fullMask: '+423(###)###-####',
            fullLength: 13,
        },
        currency: {
            name: 'Liechtenstein',
            code: 'USD',
            units: 0,
        },
        name: 'Liechtenstein',
        countryCode: '438',
        iso3166: 'ISO 3166-2:LI',
        region: 'Europe',
        subRegion: 'Western Europe',
        intermediateRegion: '',
        regionCode: '150',
        subRegionCode: '155',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_liechtenstein',
        shortCountryNameKey: 'shortCountryNameKey_liechtenstein',
        code2: 'LI',
        code3: 'LIE',
    },
    {
        phone: {
            mask: '(###)##-###',
            dialCode: '+370',
            length: 8,
            fullMask: '+370(###)##-###',
            fullLength: 11,
        },
        currency: {
            name: 'Lithuania',
            code: 'LTL',
            units: 0,
        },
        name: 'Lithuania',
        countryCode: '440',
        iso3166: 'ISO 3166-2:LT',
        region: 'Europe',
        subRegion: 'Northern Europe',
        intermediateRegion: '',
        regionCode: '150',
        subRegionCode: '154',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_lithuania',
        shortCountryNameKey: 'shortCountryNameKey_lithuania',
        code2: 'LT',
        code3: 'LTU',
    },
    {
        phone: {
            mask: '(###)###-###',
            dialCode: '+352',
            length: 9,
            fullMask: '+352(###)###-###',
            fullLength: 12,
        },
        currency: {
            name: 'Luxembourg',
            code: 'USD',
            units: 0,
        },
        name: 'Luxembourg',
        countryCode: '442',
        iso3166: 'ISO 3166-2:LU',
        region: 'Europe',
        subRegion: 'Western Europe',
        intermediateRegion: '',
        regionCode: '150',
        subRegionCode: '155',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_luxembourg',
        shortCountryNameKey: 'shortCountryNameKey_luxembourg',
        code2: 'LU',
        code3: 'LUX',
    },
    {
        phone: {
            mask: '####-####',
            dialCode: '+853',
            length: 8,
            fullMask: '+853-####-####',
            fullLength: 11,
        },
        currency: {
            name: 'Pataca',
            code: 'MOP',
            units: 2,
        },
        name: 'Macao',
        countryCode: '446',
        iso3166: 'ISO 3166-2:MO',
        region: 'Asia',
        subRegion: 'Eastern Asia',
        intermediateRegion: '',
        regionCode: '142',
        subRegionCode: '030',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_macau',
        shortCountryNameKey: 'shortCountryNameKey_macau',
        code2: 'MO',
        code3: 'MAC',
    },
    {
        phone: {
            mask: '##-##-#####',
            dialCode: '+261',
            length: 9,
            fullMask: '+261-##-##-#####',
            fullLength: 12,
        },
        currency: {
            name: 'Madagascar',
            code: 'MGF',
            units: 0,
        },
        name: 'Madagascar',
        countryCode: '450',
        iso3166: 'ISO 3166-2:MG',
        region: 'Africa',
        subRegion: 'Sub-Saharan Africa',
        intermediateRegion: 'Eastern Africa',
        regionCode: '002',
        subRegionCode: '202',
        intermediateRegionCode: '014',
        countryNameKey: 'countryNameKey_madagascar',
        shortCountryNameKey: 'shortCountryNameKey_madagascar',
        code2: 'MG',
        code3: 'MDG',
    },
    {
        phone: {
            mask: '#-####-####',
            dialCode: '+265',
            length: 9,
            fullMask: '+265-#-####-####',
            fullLength: 12,
        },
        currency: {
            name: 'Malawi Kwacha',
            code: 'MWK',
            units: 2,
        },
        name: 'Malawi',
        countryCode: '454',
        iso3166: 'ISO 3166-2:MW',
        region: 'Africa',
        subRegion: 'Sub-Saharan Africa',
        intermediateRegion: 'Eastern Africa',
        regionCode: '002',
        subRegionCode: '202',
        intermediateRegionCode: '014',
        countryNameKey: 'countryNameKey_malawi',
        shortCountryNameKey: 'shortCountryNameKey_malawi',
        code2: 'MW',
        code3: 'MWI',
    },
    {
        phone: {
            mask: '#-###-###',
            dialCode: '+60',
            length: 7,
            fullMask: '+60-#-###-###',
            fullLength: 9,
        },
        currency: {
            name: 'Malaysian Ringgit',
            code: 'MYR',
            units: 2,
        },
        name: 'Malaysia',
        countryCode: '458',
        iso3166: 'ISO 3166-2:MY',
        region: 'Asia',
        subRegion: 'South-eastern Asia',
        intermediateRegion: '',
        regionCode: '142',
        subRegionCode: '035',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_malaysia',
        shortCountryNameKey: 'shortCountryNameKey_malaysia',
        code2: 'MY',
        code3: 'MYS',
    },
    {
        phone: {
            mask: '###-####',
            dialCode: '+960',
            length: 7,
            fullMask: '+960-###-####',
            fullLength: 10,
        },
        currency: {
            name: 'Rufiyaa',
            code: 'MVR',
            units: 2,
        },
        name: 'Maldives',
        countryCode: '462',
        iso3166: 'ISO 3166-2:MV',
        region: 'Asia',
        subRegion: 'Southern Asia',
        intermediateRegion: '',
        regionCode: '142',
        subRegionCode: '034',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_maldives',
        shortCountryNameKey: 'shortCountryNameKey_maldives',
        code2: 'MV',
        code3: 'MDV',
    },
    {
        phone: {
            mask: '##-##-####',
            dialCode: '+223',
            length: 8,
            fullMask: '+223-##-##-####',
            fullLength: 11,
        },
        currency: {
            name: 'Mali',
            code: 'USD',
            units: 0,
        },
        name: 'Mali',
        countryCode: '466',
        iso3166: 'ISO 3166-2:ML',
        region: 'Africa',
        subRegion: 'Sub-Saharan Africa',
        intermediateRegion: 'Western Africa',
        regionCode: '002',
        subRegionCode: '202',
        intermediateRegionCode: '011',
        countryNameKey: 'countryNameKey_mali',
        shortCountryNameKey: 'shortCountryNameKey_mali',
        code2: 'ML',
        code3: 'MLI',
    },
    {
        phone: {
            mask: '####-####',
            dialCode: '+356',
            length: 8,
            fullMask: '+356-####-####',
            fullLength: 11,
        },
        currency: {
            name: 'Malta',
            code: 'EUR',
            units: 0,
        },
        name: 'Malta',
        countryCode: '470',
        iso3166: 'ISO 3166-2:MT',
        region: 'Europe',
        subRegion: 'Southern Europe',
        intermediateRegion: '',
        regionCode: '150',
        subRegionCode: '039',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_malta',
        shortCountryNameKey: 'shortCountryNameKey_malta',
        code2: 'MT',
        code3: 'MLT',
    },
    {
        phone: {
            mask: '###-####',
            dialCode: '+692',
            length: 7,
            fullMask: '+692-###-####',
            fullLength: 10,
        },
        currency: {
            name: 'Marshall Islands',
            code: 'USD',
            units: 0,
        },
        name: 'Marshall Islands',
        countryCode: '584',
        iso3166: 'ISO 3166-2:MH',
        region: 'Oceania',
        subRegion: 'Micronesia',
        intermediateRegion: '',
        regionCode: '009',
        subRegionCode: '057',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_marshall_islands',
        shortCountryNameKey: 'shortCountryNameKey_marshall_islands',
        code2: 'MH',
        code3: 'MHL',
    },
    {
        phone: {
            mask: '(###)##-##-##',
            dialCode: '+596',
            length: 9,
            fullMask: '+596(###)##-##-##',
            fullLength: 12,
        },
        currency: {
            name: 'Martinique',
            code: 'USD',
            units: 0,
        },
        name: 'Martinique',
        countryCode: '474',
        iso3166: 'ISO 3166-2:MQ',
        region: 'Americas',
        subRegion: 'Latin America and the Caribbean',
        intermediateRegion: 'Caribbean',
        regionCode: '019',
        subRegionCode: '419',
        intermediateRegionCode: '029',
        countryNameKey: 'countryNameKey_martinique',
        shortCountryNameKey: 'shortCountryNameKey_martinique',
        code2: 'MQ',
        code3: 'MTQ',
    },
    {
        phone: {
            mask: '##-##-####',
            dialCode: '+222',
            length: 8,
            fullMask: '+222-##-##-####',
            fullLength: 11,
        },
        currency: {
            name: 'Ouguiya',
            code: 'MRO',
            units: 2,
        },
        name: 'Mauritania',
        countryCode: '478',
        iso3166: 'ISO 3166-2:MR',
        region: 'Africa',
        subRegion: 'Sub-Saharan Africa',
        intermediateRegion: 'Western Africa',
        regionCode: '002',
        subRegionCode: '202',
        intermediateRegionCode: '011',
        countryNameKey: 'countryNameKey_mauritania',
        shortCountryNameKey: 'shortCountryNameKey_mauritania',
        code2: 'MR',
        code3: 'MRT',
    },
    {
        phone: {
            mask: '###-####',
            dialCode: '+230',
            length: 7,
            fullMask: '+230-###-####',
            fullLength: 10,
        },
        currency: {
            name: 'Mauritius Rupee',
            code: 'MUR',
            units: 2,
        },
        name: 'Mauritius',
        countryCode: '480',
        iso3166: 'ISO 3166-2:MU',
        region: 'Africa',
        subRegion: 'Sub-Saharan Africa',
        intermediateRegion: 'Eastern Africa',
        regionCode: '002',
        subRegionCode: '202',
        intermediateRegionCode: '014',
        countryNameKey: 'countryNameKey_mauritius',
        shortCountryNameKey: 'shortCountryNameKey_mauritius',
        code2: 'MU',
        code3: 'MUS',
    },
    {
        phone: {
            mask: '##-##-####',
            dialCode: '+52',
            length: 8,
            fullMask: '+52-##-##-####',
            fullLength: 10,
        },
        currency: {
            name: 'Mexican Peso',
            code: 'MXN',
            units: 2,
        },
        name: 'Mexico',
        countryCode: '484',
        iso3166: 'ISO 3166-2:MX',
        region: 'Americas',
        subRegion: 'Latin America and the Caribbean',
        intermediateRegion: 'Central America',
        regionCode: '019',
        subRegionCode: '419',
        intermediateRegionCode: '013',
        countryNameKey: 'countryNameKey_mexico',
        shortCountryNameKey: 'shortCountryNameKey_mexico',
        code2: 'MX',
        code3: 'MEX',
    },
    {
        phone: {
            mask: '####-####',
            dialCode: '+373',
            length: 8,
            fullMask: '+373-####-####',
            fullLength: 11,
        },
        currency: {
            name: 'Moldovan Leu',
            code: 'MDL',
            units: 2,
        },
        name: 'Moldova (Republic of)',
        countryCode: '498',
        iso3166: 'ISO 3166-2:MD',
        region: 'Europe',
        subRegion: 'Eastern Europe',
        intermediateRegion: '',
        regionCode: '150',
        subRegionCode: '151',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_moldova',
        shortCountryNameKey: 'shortCountryNameKey_moldova',
        code2: 'MD',
        code3: 'MDA',
    },
    {
        phone: {
            mask: '(###)###-###',
            dialCode: '+377',
            length: 9,
            fullMask: '+377(###)###-###',
            fullLength: 12,
        },
        currency: {
            name: 'Monaco',
            code: 'USD',
            units: 0,
        },
        name: 'Monaco',
        countryCode: '492',
        iso3166: 'ISO 3166-2:MC',
        region: 'Europe',
        subRegion: 'Western Europe',
        intermediateRegion: '',
        regionCode: '150',
        subRegionCode: '155',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_monaco',
        shortCountryNameKey: 'shortCountryNameKey_monaco',
        code2: 'MC',
        code3: 'MCO',
    },
    {
        phone: {
            mask: '##-##-####',
            dialCode: '+976',
            length: 8,
            fullMask: '+976-##-##-####',
            fullLength: 11,
        },
        currency: {
            name: 'Tugrik',
            code: 'MNT',
            units: 2,
        },
        name: 'Mongolia',
        countryCode: '496',
        iso3166: 'ISO 3166-2:MN',
        region: 'Asia',
        subRegion: 'Eastern Asia',
        intermediateRegion: '',
        regionCode: '142',
        subRegionCode: '030',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_mongolia',
        shortCountryNameKey: 'shortCountryNameKey_mongolia',
        code2: 'MN',
        code3: 'MNG',
    },
    {
        phone: {
            mask: '##-###-###',
            dialCode: '+382',
            length: 8,
            fullMask: '+382-##-###-###',
            fullLength: 11,
        },
        currency: {
            name: 'Montenegro',
            code: 'USD',
            units: 0,
        },
        name: 'Montenegro',
        countryCode: '499',
        iso3166: 'ISO 3166-2:ME',
        region: 'Europe',
        subRegion: 'Southern Europe',
        intermediateRegion: '',
        regionCode: '150',
        subRegionCode: '039',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_montenegro',
        shortCountryNameKey: 'shortCountryNameKey_montenegro',
        code2: 'ME',
        code3: 'MNE',
    },
    {
        phone: {
            mask: '###-####',
            dialCode: '+1664',
            length: 7,
            fullMask: '+1(664)###-####',
            fullLength: 11,
        },
        currency: {
            name: 'Montserrat',
            code: 'USD',
            units: 0,
        },
        name: 'Montserrat',
        countryCode: '500',
        iso3166: 'ISO 3166-2:MS',
        region: 'Americas',
        subRegion: 'Latin America and the Caribbean',
        intermediateRegion: 'Caribbean',
        regionCode: '019',
        subRegionCode: '419',
        intermediateRegionCode: '029',
        countryNameKey: 'countryNameKey_montserrat',
        shortCountryNameKey: 'shortCountryNameKey_montserrat',
        code2: 'MS',
        code3: 'MSR',
    },
    {
        phone: {
            mask: '##-####-###',
            dialCode: '+212',
            length: 9,
            fullMask: '+212-##-####-###',
            fullLength: 12,
        },
        currency: {
            name: 'Moroccan Dirham',
            code: 'MAD',
            units: 2,
        },
        name: 'Morocco',
        countryCode: '504',
        iso3166: 'ISO 3166-2:MA',
        region: 'Africa',
        subRegion: 'Northern Africa',
        intermediateRegion: '',
        regionCode: '002',
        subRegionCode: '015',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_morocco',
        shortCountryNameKey: 'shortCountryNameKey_morocco',
        code2: 'MA',
        code3: 'MAR',
    },
    {
        phone: {
            mask: '##-###-###',
            dialCode: '+258',
            length: 8,
            fullMask: '+258-##-###-###',
            fullLength: 11,
        },
        currency: {
            name: 'Mozambique',
            code: 'USD',
            units: 0,
        },
        name: 'Mozambique',
        countryCode: '508',
        iso3166: 'ISO 3166-2:MZ',
        region: 'Africa',
        subRegion: 'Sub-Saharan Africa',
        intermediateRegion: 'Eastern Africa',
        regionCode: '002',
        subRegionCode: '202',
        intermediateRegionCode: '014',
        countryNameKey: 'countryNameKey_mozambique',
        shortCountryNameKey: 'shortCountryNameKey_mozambique',
        code2: 'MZ',
        code3: 'MOZ',
    },
    {
        phone: {
            mask: '##-###-####',
            dialCode: '+264',
            length: 9,
            fullMask: '+264-##-###-####',
            fullLength: 12,
        },
        currency: {
            name: 'Namibia Dollar',
            code: 'NAD',
            units: 2,
        },
        name: 'Namibia',
        countryCode: '516',
        iso3166: 'ISO 3166-2:NA',
        region: 'Africa',
        subRegion: 'Sub-Saharan Africa',
        intermediateRegion: 'Southern Africa',
        regionCode: '002',
        subRegionCode: '202',
        intermediateRegionCode: '018',
        countryNameKey: 'countryNameKey_namibia',
        shortCountryNameKey: 'shortCountryNameKey_namibia',
        code2: 'NA',
        code3: 'NAM',
    },
    {
        phone: {
            mask: '###-####',
            dialCode: '+674',
            length: 7,
            fullMask: '+674-###-####',
            fullLength: 10,
        },
        currency: {
            name: 'Nauru',
            code: 'USD',
            units: 0,
        },
        name: 'Nauru',
        countryCode: '520',
        iso3166: 'ISO 3166-2:NR',
        region: 'Oceania',
        subRegion: 'Micronesia',
        intermediateRegion: '',
        regionCode: '009',
        subRegionCode: '057',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_nauru',
        shortCountryNameKey: 'shortCountryNameKey_nauru',
        code2: 'NR',
        code3: 'NRU',
    },
    {
        phone: {
            mask: '##-###-###',
            dialCode: '+977',
            length: 8,
            fullMask: '+977-##-###-###',
            fullLength: 11,
        },
        currency: {
            name: 'Nepalese Rupee',
            code: 'NPR',
            units: 2,
        },
        name: 'Nepal',
        countryCode: '524',
        iso3166: 'ISO 3166-2:NP',
        region: 'Asia',
        subRegion: 'Southern Asia',
        intermediateRegion: '',
        regionCode: '142',
        subRegionCode: '034',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_nepal',
        shortCountryNameKey: 'shortCountryNameKey_nepal',
        code2: 'NP',
        code3: 'NPL',
    },
    {
        phone: {
            mask: '##-###-####',
            dialCode: '+31',
            length: 9,
            fullMask: '+31-##-###-####',
            fullLength: 11,
        },
        currency: {
            name: 'Netherlands',
            code: 'EUR',
            units: 0,
        },
        name: 'Netherlands',
        countryCode: '528',
        iso3166: 'ISO 3166-2:NL',
        region: 'Europe',
        subRegion: 'Western Europe',
        intermediateRegion: '',
        regionCode: '150',
        subRegionCode: '155',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_netherlands',
        shortCountryNameKey: 'shortCountryNameKey_netherlands',
        code2: 'NL',
        code3: 'NLD',
    },
    {
        phone: {
            mask: '##-####',
            dialCode: '+687',
            length: 6,
            fullMask: '+687-##-####',
            fullLength: 9,
        },
        currency: {
            name: 'New Caledonia',
            code: 'USD',
            units: 0,
        },
        name: 'New Caledonia',
        countryCode: '540',
        iso3166: 'ISO 3166-2:NC',
        region: 'Oceania',
        subRegion: 'Melanesia',
        intermediateRegion: '',
        regionCode: '009',
        subRegionCode: '054',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_new_caledonia',
        shortCountryNameKey: 'shortCountryNameKey_new_caledonia',
        code2: 'NC',
        code3: 'NCL',
    },
    {
        phone: {
            mask: '(###)###-####',
            dialCode: '+64',
            length: 10,
            fullMask: '+64(###)###-####',
            fullLength: 12,
        },
        currency: {
            name: 'New Zealand Dollar',
            code: 'NZD',
            units: 2,
        },
        name: 'New Zealand',
        countryCode: '554',
        iso3166: 'ISO 3166-2:NZ',
        region: 'Oceania',
        subRegion: 'Australia and New Zealand',
        intermediateRegion: '',
        regionCode: '009',
        subRegionCode: '053',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_new_zealand',
        shortCountryNameKey: 'shortCountryNameKey_new_zealand',
        code2: 'NZ',
        code3: 'NZL',
    },
    {
        phone: {
            mask: '####-####',
            dialCode: '+505',
            length: 8,
            fullMask: '+505-####-####',
            fullLength: 11,
        },
        currency: {
            name: 'Cordoba Oro',
            code: 'NIO',
            units: 2,
        },
        name: 'Nicaragua',
        countryCode: '558',
        iso3166: 'ISO 3166-2:NI',
        region: 'Americas',
        subRegion: 'Latin America and the Caribbean',
        intermediateRegion: 'Central America',
        regionCode: '019',
        subRegionCode: '419',
        intermediateRegionCode: '013',
        countryNameKey: 'countryNameKey_nicaragua',
        shortCountryNameKey: 'shortCountryNameKey_nicaragua',
        code2: 'NI',
        code3: 'NIC',
    },
    {
        phone: {
            mask: '##-##-####',
            dialCode: '+227',
            length: 8,
            fullMask: '+227-##-##-####',
            fullLength: 11,
        },
        currency: {
            name: 'Niger',
            code: 'USD',
            units: 0,
        },
        name: 'Niger',
        countryCode: '562',
        iso3166: 'ISO 3166-2:NE',
        region: 'Africa',
        subRegion: 'Sub-Saharan Africa',
        intermediateRegion: 'Western Africa',
        regionCode: '002',
        subRegionCode: '202',
        intermediateRegionCode: '011',
        countryNameKey: 'countryNameKey_niger',
        shortCountryNameKey: 'shortCountryNameKey_niger',
        code2: 'NE',
        code3: 'NER',
    },
    {
        phone: {
            mask: '##-###-###',
            dialCode: '+234',
            length: 8,
            fullMask: '+234-##-###-###',
            fullLength: 11,
        },
        currency: {
            name: 'Naira',
            code: 'NGN',
            units: 2,
        },
        name: 'Nigeria',
        countryCode: '566',
        iso3166: 'ISO 3166-2:NG',
        region: 'Africa',
        subRegion: 'Sub-Saharan Africa',
        intermediateRegion: 'Western Africa',
        regionCode: '002',
        subRegionCode: '202',
        intermediateRegionCode: '011',
        countryNameKey: 'countryNameKey_nigeria',
        shortCountryNameKey: 'shortCountryNameKey_nigeria',
        code2: 'NG',
        code3: 'NGA',
    },
    {
        phone: {
            mask: '####',
            dialCode: '+683',
            length: 4,
            fullMask: '+683-####',
            fullLength: 7,
        },
        currency: {
            name: 'Niue',
            code: 'USD',
            units: 0,
        },
        name: 'Niue',
        countryCode: '570',
        iso3166: 'ISO 3166-2:NU',
        region: 'Oceania',
        subRegion: 'Polynesia',
        intermediateRegion: '',
        regionCode: '009',
        subRegionCode: '061',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_niue',
        shortCountryNameKey: 'shortCountryNameKey_niue',
        code2: 'NU',
        code3: 'NIU',
    },
    {
        phone: {
            mask: '##-###',
            dialCode: '+6723',
            length: 5,
            fullMask: '+672-3##-###',
            fullLength: 9,
        },
        currency: {
            name: 'Norfolk Island',
            code: 'USD',
            units: 0,
        },
        name: 'Norfolk Island',
        countryCode: '574',
        iso3166: 'ISO 3166-2:NF',
        region: 'Oceania',
        subRegion: 'Australia and New Zealand',
        intermediateRegion: '',
        regionCode: '009',
        subRegionCode: '053',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_norfolk_island',
        shortCountryNameKey: 'shortCountryNameKey_norfolk_island',
        code2: 'NF',
        code3: 'NFK',
    },
    {
        phone: {
            mask: '###-####',
            dialCode: '+1670',
            length: 7,
            fullMask: '+1(670)###-####',
            fullLength: 11,
        },
        currency: {
            name: 'Northern Mariana Islands',
            code: 'USD',
            units: 0,
        },
        name: 'Northern Mariana Islands',
        countryCode: '580',
        iso3166: 'ISO 3166-2:MP',
        region: 'Oceania',
        subRegion: 'Micronesia',
        intermediateRegion: '',
        regionCode: '009',
        subRegionCode: '057',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_northern_mariana_islands',
        shortCountryNameKey: 'shortCountryNameKey_northern_mariana_islands',
        code2: 'MP',
        code3: 'MNP',
    },
    {
        phone: {
            mask: '(###)##-###',
            dialCode: '+47',
            length: 8,
            fullMask: '+47(###)##-###',
            fullLength: 10,
        },
        currency: {
            name: 'Norwegian Krone',
            code: 'NOK',
            units: 2,
        },
        name: 'Norway',
        countryCode: '578',
        iso3166: 'ISO 3166-2:NO',
        region: 'Europe',
        subRegion: 'Northern Europe',
        intermediateRegion: '',
        regionCode: '150',
        subRegionCode: '154',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_norway',
        shortCountryNameKey: 'shortCountryNameKey_norway',
        code2: 'NO',
        code3: 'NOR',
    },
    {
        phone: {
            mask: '##-###-###',
            dialCode: '+968',
            length: 8,
            fullMask: '+968-##-###-###',
            fullLength: 11,
        },
        currency: {
            name: 'Rial Omani',
            code: 'OMR',
            units: 3,
        },
        name: 'Oman',
        countryCode: '512',
        iso3166: 'ISO 3166-2:OM',
        region: 'Asia',
        subRegion: 'Western Asia',
        intermediateRegion: '',
        regionCode: '142',
        subRegionCode: '145',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_oman',
        shortCountryNameKey: 'shortCountryNameKey_oman',
        code2: 'OM',
        code3: 'OMN',
    },
    {
        phone: {
            mask: '(###)###-####',
            dialCode: '+92',
            length: 10,
            fullMask: '+92(###)###-####',
            fullLength: 12,
        },
        currency: {
            name: 'Pakistan Rupee',
            code: 'PKR',
            units: 2,
        },
        name: 'Pakistan',
        countryCode: '586',
        iso3166: 'ISO 3166-2:PK',
        region: 'Asia',
        subRegion: 'Southern Asia',
        intermediateRegion: '',
        regionCode: '142',
        subRegionCode: '034',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_pakistan',
        shortCountryNameKey: 'shortCountryNameKey_pakistan',
        code2: 'PK',
        code3: 'PAK',
    },
    {
        phone: {
            mask: '###-####',
            dialCode: '+680',
            length: 7,
            fullMask: '+680-###-####',
            fullLength: 10,
        },
        currency: {
            name: 'Palau',
            code: 'USD',
            units: 0,
        },
        name: 'Palau',
        countryCode: '585',
        iso3166: 'ISO 3166-2:PW',
        region: 'Oceania',
        subRegion: 'Micronesia',
        intermediateRegion: '',
        regionCode: '009',
        subRegionCode: '057',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_palau',
        shortCountryNameKey: 'shortCountryNameKey_palau',
        code2: 'PW',
        code3: 'PLW',
    },
    {
        phone: {
            mask: '##-###-####',
            dialCode: '+970',
            length: 9,
            fullMask: '+970-##-###-####',
            fullLength: 12,
        },
        currency: {
            name: 'Palestinian Territory',
            code: 'JOD',
            units: 0,
        },
        name: 'Palestine, State of',
        countryCode: '275',
        iso3166: 'ISO 3166-2:PS',
        region: 'Asia',
        subRegion: 'Western Asia',
        intermediateRegion: '',
        regionCode: '142',
        subRegionCode: '145',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_palestine',
        shortCountryNameKey: 'shortCountryNameKey_palestine',
        code2: 'PS',
        code3: 'PSE',
    },
    {
        phone: {
            mask: '###-####',
            dialCode: '+507',
            length: 7,
            fullMask: '+507-###-####',
            fullLength: 10,
        },
        currency: {
            name: 'Panama',
            code: 'USD',
            units: 0,
        },
        name: 'Panama',
        countryCode: '591',
        iso3166: 'ISO 3166-2:PA',
        region: 'Americas',
        subRegion: 'Latin America and the Caribbean',
        intermediateRegion: 'Central America',
        regionCode: '019',
        subRegionCode: '419',
        intermediateRegionCode: '013',
        countryNameKey: 'countryNameKey_panama',
        shortCountryNameKey: 'shortCountryNameKey_panama',
        code2: 'PA',
        code3: 'PAN',
    },
    {
        phone: {
            mask: '(###)##-###',
            dialCode: '+675',
            length: 8,
            fullMask: '+675(###)##-###',
            fullLength: 11,
        },
        currency: {
            name: 'Kina',
            code: 'PGK',
            units: 2,
        },
        name: 'Papua New Guinea',
        countryCode: '598',
        iso3166: 'ISO 3166-2:PG',
        region: 'Oceania',
        subRegion: 'Melanesia',
        intermediateRegion: '',
        regionCode: '009',
        subRegionCode: '054',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_papua_new_guinea',
        shortCountryNameKey: 'shortCountryNameKey_papua_new_guinea',
        code2: 'PG',
        code3: 'PNG',
    },
    {
        phone: {
            mask: '(###)###-###',
            dialCode: '+595',
            length: 9,
            fullMask: '+595(###)###-###',
            fullLength: 12,
        },
        currency: {
            name: 'Guarani',
            code: 'PYG',
            units: 0,
        },
        name: 'Paraguay',
        countryCode: '600',
        iso3166: 'ISO 3166-2:PY',
        region: 'Americas',
        subRegion: 'Latin America and the Caribbean',
        intermediateRegion: 'South America',
        regionCode: '019',
        subRegionCode: '419',
        intermediateRegionCode: '005',
        countryNameKey: 'countryNameKey_paraguay',
        shortCountryNameKey: 'shortCountryNameKey_paraguay',
        code2: 'PY',
        code3: 'PRY',
    },
    {
        phone: {
            mask: '(###)###-###',
            dialCode: '+51',
            length: 9,
            fullMask: '+51(###)###-###',
            fullLength: 11,
        },
        currency: {
            name: 'Sol',
            code: 'PEN',
            units: 2,
        },
        name: 'Peru',
        countryCode: '604',
        iso3166: 'ISO 3166-2:PE',
        region: 'Americas',
        subRegion: 'Latin America and the Caribbean',
        intermediateRegion: 'South America',
        regionCode: '019',
        subRegionCode: '419',
        intermediateRegionCode: '005',
        countryNameKey: 'countryNameKey_peru',
        shortCountryNameKey: 'shortCountryNameKey_peru',
        code2: 'PE',
        code3: 'PER',
    },
    {
        phone: {
            mask: '(###)###-####',
            dialCode: '+63',
            length: 10,
            fullMask: '+63(###)###-####',
            fullLength: 12,
        },
        currency: {
            name: 'Philippine Peso',
            code: 'PHP',
            units: 2,
        },
        name: 'Philippines',
        countryCode: '608',
        iso3166: 'ISO 3166-2:PH',
        region: 'Asia',
        subRegion: 'South-eastern Asia',
        intermediateRegion: '',
        regionCode: '142',
        subRegionCode: '035',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_philippines',
        shortCountryNameKey: 'shortCountryNameKey_philippines',
        code2: 'PH',
        code3: 'PHL',
    },
    {
        phone: {
            mask: '(###)###-###',
            dialCode: '+48',
            length: 9,
            fullMask: '+48(###)###-###',
            fullLength: 11,
        },
        currency: {
            name: 'Poland',
            code: 'PLN',
            units: 0,
        },
        name: 'Poland',
        countryCode: '616',
        iso3166: 'ISO 3166-2:PL',
        region: 'Europe',
        subRegion: 'Eastern Europe',
        intermediateRegion: '',
        regionCode: '150',
        subRegionCode: '151',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_poland',
        shortCountryNameKey: 'shortCountryNameKey_poland',
        code2: 'PL',
        code3: 'POL',
    },
    {
        phone: {
            mask: '##-###-####',
            dialCode: '+351',
            length: 9,
            fullMask: '+351-##-###-####',
            fullLength: 12,
        },
        currency: {
            name: 'Portugal',
            code: 'EUR',
            units: 0,
        },
        name: 'Portugal',
        countryCode: '620',
        iso3166: 'ISO 3166-2:PT',
        region: 'Europe',
        subRegion: 'Southern Europe',
        intermediateRegion: '',
        regionCode: '150',
        subRegionCode: '039',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_portugal',
        shortCountryNameKey: 'shortCountryNameKey_portugal',
        code2: 'PT',
        code3: 'PRT',
    },
    {
        phone: {
            mask: '####-####',
            dialCode: '+974',
            length: 8,
            fullMask: '+974-####-####',
            fullLength: 11,
        },
        currency: {
            name: 'Qatari Rial',
            code: 'QAR',
            units: 2,
        },
        name: 'Qatar',
        countryCode: '634',
        iso3166: 'ISO 3166-2:QA',
        region: 'Asia',
        subRegion: 'Western Asia',
        intermediateRegion: '',
        regionCode: '142',
        subRegionCode: '145',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_qatar',
        shortCountryNameKey: 'shortCountryNameKey_qatar',
        code2: 'QA',
        code3: 'QAT',
    },
    {
        phone: {
            mask: '(###)###-###',
            dialCode: '+995',
            length: 9,
            fullMask: '+995(###)###-###',
            fullLength: 12,
        },
        currency: {
            name: 'Georgia',
            code: 'USD',
            units: 0,
        },
        name: 'Georgia',
        countryCode: '268',
        iso3166: 'ISO 3166-2:GE',
        region: 'Asia',
        subRegion: 'Western Asia',
        intermediateRegion: '',
        regionCode: '142',
        subRegionCode: '145',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_rep._of_georgia',
        shortCountryNameKey: 'shortCountryNameKey_rep._of_georgia',
        code2: 'GE',
        code3: 'GEO',
    },
    {
        phone: {
            mask: '##-###-###',
            dialCode: '+389',
            length: 8,
            fullMask: '+389-##-###-###',
            fullLength: 11,
        },
        currency: {
            name: 'Denar',
            code: 'MKD',
            units: 2,
        },
        name: 'Macedonia (the former Yugoslav Republic of)',
        countryCode: '807',
        iso3166: 'ISO 3166-2:MK',
        region: 'Europe',
        subRegion: 'Southern Europe',
        intermediateRegion: '',
        regionCode: '150',
        subRegionCode: '039',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_republic_of_macedonia',
        shortCountryNameKey: 'shortCountryNameKey_republic_of_macedonia',
        code2: 'MK',
        code3: 'MKD',
    },
    {
        phone: {
            mask: '#####-####',
            dialCode: '+262',
            length: 9,
            fullMask: '+262-#####-####',
            fullLength: 12,
        },
        currency: {
            name: 'Réunion',
            code: 'USD',
            units: 0,
        },
        name: 'Réunion',
        countryCode: '638',
        iso3166: 'ISO 3166-2:RE',
        region: 'Africa',
        subRegion: 'Sub-Saharan Africa',
        intermediateRegion: 'Eastern Africa',
        regionCode: '002',
        subRegionCode: '202',
        intermediateRegionCode: '014',
        countryNameKey: 'countryNameKey_reunion',
        shortCountryNameKey: 'shortCountryNameKey_reunion',
        code2: 'RE',
        code3: 'REU',
    },
    {
        phone: {
            mask: '##-###-####',
            dialCode: '+40',
            length: 9,
            fullMask: '+40-##-###-####',
            fullLength: 11,
        },
        currency: {
            name: 'Romania',
            code: 'RON',
            units: 0,
        },
        name: 'Romania',
        countryCode: '642',
        iso3166: 'ISO 3166-2:RO',
        region: 'Europe',
        subRegion: 'Eastern Europe',
        intermediateRegion: '',
        regionCode: '150',
        subRegionCode: '151',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_romania',
        shortCountryNameKey: 'shortCountryNameKey_romania',
        code2: 'RO',
        code3: 'ROU',
    },
    {
        phone: {
            mask: '(###)###-##-##',
            dialCode: '+7',
            length: 10,
            fullMask: '+7(###)###-##-##',
            fullLength: 11,
        },
        currency: {
            name: 'Russian Ruble',
            code: 'RUB',
            units: 2,
        },
        name: 'Russian Federation',
        countryCode: '643',
        iso3166: 'ISO 3166-2:RU',
        region: 'Europe',
        subRegion: 'Eastern Europe',
        intermediateRegion: '',
        regionCode: '150',
        subRegionCode: '151',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_russia',
        shortCountryNameKey: 'shortCountryNameKey_russia',
        code2: 'RU',
        code3: 'RUS',
    },
    {
        phone: {
            mask: '(###)###-###',
            dialCode: '+250',
            length: 9,
            fullMask: '+250(###)###-###',
            fullLength: 12,
        },
        currency: {
            name: 'Rwanda Franc',
            code: 'RWF',
            units: 0,
        },
        name: 'Rwanda',
        countryCode: '646',
        iso3166: 'ISO 3166-2:RW',
        region: 'Africa',
        subRegion: 'Sub-Saharan Africa',
        intermediateRegion: 'Eastern Africa',
        regionCode: '002',
        subRegionCode: '202',
        intermediateRegionCode: '014',
        countryNameKey: 'countryNameKey_rwanda',
        shortCountryNameKey: 'shortCountryNameKey_rwanda',
        code2: 'RW',
        code3: 'RWA',
    },
    {
        phone: {
            mask: '####',
            dialCode: '+290',
            length: 4,
            fullMask: '+290-####',
            fullLength: 7,
        },
        currency: {
            name: 'Saint Helena Pound',
            code: 'SHP',
            units: 2,
        },
        name: 'Saint Helena, Ascension and Tristan da Cunha',
        countryCode: '654',
        iso3166: 'ISO 3166-2:SH',
        region: 'Africa',
        subRegion: 'Sub-Saharan Africa',
        intermediateRegion: 'Western Africa',
        regionCode: '002',
        subRegionCode: '202',
        intermediateRegionCode: '011',
        countryNameKey: 'countryNameKey_saint_helena',
        shortCountryNameKey: 'shortCountryNameKey_saint_helena',
        code2: 'SH',
        code3: 'SHN',
    },
    {
        phone: {
            mask: '###-####',
            dialCode: '+1869',
            length: 7,
            fullMask: '+1(869)###-####',
            fullLength: 11,
        },
        currency: {
            name: 'Saint Kitts and Nevis',
            code: 'USD',
            units: 0,
        },
        name: 'Saint Kitts and Nevis',
        countryCode: '659',
        iso3166: 'ISO 3166-2:KN',
        region: 'Americas',
        subRegion: 'Latin America and the Caribbean',
        intermediateRegion: 'Caribbean',
        regionCode: '019',
        subRegionCode: '419',
        intermediateRegionCode: '029',
        countryNameKey: 'countryNameKey_saint_kitts_&_nevis',
        shortCountryNameKey: 'shortCountryNameKey_saint_kitts_&_nevis',
        code2: 'KN',
        code3: 'KNA',
    },
    {
        phone: {
            mask: '###-####',
            dialCode: '+1758',
            length: 7,
            fullMask: '+1(758)###-####',
            fullLength: 11,
        },
        currency: {
            name: 'Saint Lucia',
            code: 'USD',
            units: 0,
        },
        name: 'Saint Lucia',
        countryCode: '662',
        iso3166: 'ISO 3166-2:LC',
        region: 'Americas',
        subRegion: 'Latin America and the Caribbean',
        intermediateRegion: 'Caribbean',
        regionCode: '019',
        subRegionCode: '419',
        intermediateRegionCode: '029',
        countryNameKey: 'countryNameKey_saint_lucia',
        shortCountryNameKey: 'shortCountryNameKey_saint_lucia',
        code2: 'LC',
        code3: 'LCA',
    },
    {
        phone: {
            mask: '###-####',
            dialCode: '+1784',
            length: 7,
            fullMask: '+1(784)###-####',
            fullLength: 11,
        },
        currency: {
            name: 'Saint Vincent and the Grenadines',
            code: 'USD',
            units: 0,
        },
        name: 'Saint Vincent and the Grenadines',
        countryCode: '670',
        iso3166: 'ISO 3166-2:VC',
        region: 'Americas',
        subRegion: 'Latin America and the Caribbean',
        intermediateRegion: 'Caribbean',
        regionCode: '019',
        subRegionCode: '419',
        intermediateRegionCode: '029',
        countryNameKey: 'countryNameKey_saint_vincent_&_the_grenadines',
        shortCountryNameKey: 'shortCountryNameKey_saint_vincent_&_the_grenadines',
        code2: 'VC',
        code3: 'VCT',
    },
    {
        phone: {
            mask: '##-####',
            dialCode: '+685',
            length: 6,
            fullMask: '+685-##-####',
            fullLength: 9,
        },
        currency: {
            name: 'Tala',
            code: 'WST',
            units: 2,
        },
        name: 'Samoa',
        countryCode: '882',
        iso3166: 'ISO 3166-2:WS',
        region: 'Oceania',
        subRegion: 'Polynesia',
        intermediateRegion: '',
        regionCode: '009',
        subRegionCode: '061',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_samoa',
        shortCountryNameKey: 'shortCountryNameKey_samoa',
        code2: 'WS',
        code3: 'WSM',
    },
    {
        phone: {
            mask: '####-######',
            dialCode: '+378',
            length: 10,
            fullMask: '+378-####-######',
            fullLength: 13,
        },
        currency: {
            name: 'San Marino',
            code: 'USD',
            units: 0,
        },
        name: 'San Marino',
        countryCode: '674',
        iso3166: 'ISO 3166-2:SM',
        region: 'Europe',
        subRegion: 'Southern Europe',
        intermediateRegion: '',
        regionCode: '150',
        subRegionCode: '039',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_san_marino',
        shortCountryNameKey: 'shortCountryNameKey_san_marino',
        code2: 'SM',
        code3: 'SMR',
    },
    {
        phone: {
            mask: '##-#####',
            dialCode: '+239',
            length: 7,
            fullMask: '+239-##-#####',
            fullLength: 10,
        },
        currency: {
            name: 'Dobra',
            code: 'STD',
            units: 2,
        },
        name: 'Sao Tome and Principe',
        countryCode: '678',
        iso3166: 'ISO 3166-2:ST',
        region: 'Africa',
        subRegion: 'Sub-Saharan Africa',
        intermediateRegion: 'Middle Africa',
        regionCode: '002',
        subRegionCode: '202',
        intermediateRegionCode: '017',
        countryNameKey: 'countryNameKey_sao_tome_and_principe',
        shortCountryNameKey: 'shortCountryNameKey_sao_tome_and_principe',
        code2: 'ST',
        code3: 'STP',
    },
    {
        phone: {
            mask: '#-###-####',
            dialCode: '+966',
            length: 8,
            fullMask: '+966-#-###-####',
            fullLength: 11,
        },
        currency: {
            name: 'Saudi Riyal',
            code: 'SAR',
            units: 2,
        },
        name: 'Saudi Arabia',
        countryCode: '682',
        iso3166: 'ISO 3166-2:SA',
        region: 'Asia',
        subRegion: 'Western Asia',
        intermediateRegion: '',
        regionCode: '142',
        subRegionCode: '145',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_saudi_arabia',
        shortCountryNameKey: 'shortCountryNameKey_saudi_arabia',
        code2: 'SA',
        code3: 'SAU',
    },
    {
        phone: {
            mask: '##-###-####',
            dialCode: '+221',
            length: 9,
            fullMask: '+221-##-###-####',
            fullLength: 12,
        },
        currency: {
            name: 'Senegal',
            code: 'USD',
            units: 0,
        },
        name: 'Senegal',
        countryCode: '686',
        iso3166: 'ISO 3166-2:SN',
        region: 'Africa',
        subRegion: 'Sub-Saharan Africa',
        intermediateRegion: 'Western Africa',
        regionCode: '002',
        subRegionCode: '202',
        intermediateRegionCode: '011',
        countryNameKey: 'countryNameKey_senegal',
        shortCountryNameKey: 'shortCountryNameKey_senegal',
        code2: 'SN',
        code3: 'SEN',
    },
    {
        phone: {
            mask: '##-###-####',
            dialCode: '+381',
            length: 9,
            fullMask: '+381-##-###-####',
            fullLength: 12,
        },
        currency: {
            name: 'Serbia',
            code: 'RSD',
            units: 0,
        },
        name: 'Serbia',
        countryCode: '688',
        iso3166: 'ISO 3166-2:RS',
        region: 'Europe',
        subRegion: 'Southern Europe',
        intermediateRegion: '',
        regionCode: '150',
        subRegionCode: '039',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_serbia',
        shortCountryNameKey: 'shortCountryNameKey_serbia',
        code2: 'RS',
        code3: 'SRB',
    },
    {
        phone: {
            mask: '#-###-###',
            dialCode: '+248',
            length: 7,
            fullMask: '+248-#-###-###',
            fullLength: 10,
        },
        currency: {
            name: 'Seychelles Rupee',
            code: 'SCR',
            units: 2,
        },
        name: 'Seychelles',
        countryCode: '690',
        iso3166: 'ISO 3166-2:SC',
        region: 'Africa',
        subRegion: 'Sub-Saharan Africa',
        intermediateRegion: 'Eastern Africa',
        regionCode: '002',
        subRegionCode: '202',
        intermediateRegionCode: '014',
        countryNameKey: 'countryNameKey_seychelles',
        shortCountryNameKey: 'shortCountryNameKey_seychelles',
        code2: 'SC',
        code3: 'SYC',
    },
    {
        phone: {
            mask: '##-######',
            dialCode: '+232',
            length: 8,
            fullMask: '+232-##-######',
            fullLength: 11,
        },
        currency: {
            name: 'Leone',
            code: 'SLL',
            units: 2,
        },
        name: 'Sierra Leone',
        countryCode: '694',
        iso3166: 'ISO 3166-2:SL',
        region: 'Africa',
        subRegion: 'Sub-Saharan Africa',
        intermediateRegion: 'Western Africa',
        regionCode: '002',
        subRegionCode: '202',
        intermediateRegionCode: '011',
        countryNameKey: 'countryNameKey_sierra_leone',
        shortCountryNameKey: 'shortCountryNameKey_sierra_leone',
        code2: 'SL',
        code3: 'SLE',
    },
    {
        phone: {
            mask: '####-####',
            dialCode: '+65',
            length: 8,
            fullMask: '+65-####-####',
            fullLength: 10,
        },
        currency: {
            name: 'Singapore Dollar',
            code: 'SGD',
            units: 2,
        },
        name: 'Singapore',
        countryCode: '702',
        iso3166: 'ISO 3166-2:SG',
        region: 'Asia',
        subRegion: 'South-eastern Asia',
        intermediateRegion: '',
        regionCode: '142',
        subRegionCode: '035',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_singapore',
        shortCountryNameKey: 'shortCountryNameKey_singapore',
        code2: 'SG',
        code3: 'SGP',
    },
    {
        phone: {
            mask: '###-####',
            dialCode: '+1721',
            length: 7,
            fullMask: '+1(721)###-####',
            fullLength: 11,
        },
        currency: {
            name: 'Sint Maarten (Dutch part)',
            code: 'USD',
            units: 0,
        },
        name: 'Sint Maarten (Dutch part)',
        countryCode: '534',
        iso3166: 'ISO 3166-2:SX',
        region: 'Americas',
        subRegion: 'Latin America and the Caribbean',
        intermediateRegion: 'Caribbean',
        regionCode: '019',
        subRegionCode: '419',
        intermediateRegionCode: '029',
        countryNameKey: 'countryNameKey_sint_maarten',
        shortCountryNameKey: 'shortCountryNameKey_sint_maarten',
        code2: 'SX',
        code3: 'SXM',
    },
    {
        phone: {
            mask: '(###)###-###',
            dialCode: '+421',
            length: 9,
            fullMask: '+421(###)###-###',
            fullLength: 12,
        },
        currency: {
            name: 'Slovakia',
            code: 'EUR',
            units: 0,
        },
        name: 'Slovakia',
        countryCode: '703',
        iso3166: 'ISO 3166-2:SK',
        region: 'Europe',
        subRegion: 'Eastern Europe',
        intermediateRegion: '',
        regionCode: '150',
        subRegionCode: '151',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_slovakia',
        shortCountryNameKey: 'shortCountryNameKey_slovakia',
        code2: 'SK',
        code3: 'SVK',
    },
    {
        phone: {
            mask: '##-###-###',
            dialCode: '+386',
            length: 8,
            fullMask: '+386-##-###-###',
            fullLength: 11,
        },
        currency: {
            name: 'Slovenia',
            code: 'EUR',
            units: 0,
        },
        name: 'Slovenia',
        countryCode: '705',
        iso3166: 'ISO 3166-2:SI',
        region: 'Europe',
        subRegion: 'Southern Europe',
        intermediateRegion: '',
        regionCode: '150',
        subRegionCode: '039',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_slovenia',
        shortCountryNameKey: 'shortCountryNameKey_slovenia',
        code2: 'SI',
        code3: 'SVN',
    },
    {
        phone: {
            mask: '#####',
            dialCode: '+677',
            length: 5,
            fullMask: '+677-#####',
            fullLength: 8,
        },
        currency: {
            name: 'Solomon Islands Dollar',
            code: 'SBD',
            units: 2,
        },
        name: 'Solomon Islands',
        countryCode: '090',
        iso3166: 'ISO 3166-2:SB',
        region: 'Oceania',
        subRegion: 'Melanesia',
        intermediateRegion: '',
        regionCode: '009',
        subRegionCode: '054',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_solomon_islands',
        shortCountryNameKey: 'shortCountryNameKey_solomon_islands',
        code2: 'SB',
        code3: 'SLB',
    },
    {
        phone: {
            mask: '#-###-###',
            dialCode: '+252',
            length: 7,
            fullMask: '+252-#-###-###',
            fullLength: 10,
        },
        currency: {
            name: 'Somali Shilling',
            code: 'SOS',
            units: 2,
        },
        name: 'Somalia',
        countryCode: '706',
        iso3166: 'ISO 3166-2:SO',
        region: 'Africa',
        subRegion: 'Sub-Saharan Africa',
        intermediateRegion: 'Eastern Africa',
        regionCode: '002',
        subRegionCode: '202',
        intermediateRegionCode: '014',
        countryNameKey: 'countryNameKey_somalia',
        shortCountryNameKey: 'shortCountryNameKey_somalia',
        code2: 'SO',
        code3: 'SOM',
    },
    {
        phone: {
            mask: '##-###-####',
            dialCode: '+27',
            length: 9,
            fullMask: '+27-##-###-####',
            fullLength: 11,
        },
        currency: {
            name: 'Rand',
            code: 'ZAR',
            units: 2,
        },
        name: 'South Africa',
        countryCode: '710',
        iso3166: 'ISO 3166-2:ZA',
        region: 'Africa',
        subRegion: 'Sub-Saharan Africa',
        intermediateRegion: 'Southern Africa',
        regionCode: '002',
        subRegionCode: '202',
        intermediateRegionCode: '018',
        countryNameKey: 'countryNameKey_south_africa',
        shortCountryNameKey: 'shortCountryNameKey_south_africa',
        code2: 'ZA',
        code3: 'ZAF',
    },
    {
        phone: {
            mask: '##-###-####',
            dialCode: '+211',
            length: 9,
            fullMask: '+211-##-###-####',
            fullLength: 12,
        },
        currency: {
            name: 'South Sudanese Pound',
            code: 'SSP',
            units: 2,
        },
        name: 'South Sudan',
        countryCode: '728',
        iso3166: 'ISO 3166-2:SS',
        region: 'Africa',
        subRegion: 'Sub-Saharan Africa',
        intermediateRegion: 'Eastern Africa',
        regionCode: '002',
        subRegionCode: '202',
        intermediateRegionCode: '014',
        countryNameKey: 'countryNameKey_south_sudan',
        shortCountryNameKey: 'shortCountryNameKey_south_sudan',
        code2: 'SS',
        code3: 'SSD',
    },
    {
        phone: {
            mask: '(###)###-###',
            dialCode: '+34',
            length: 9,
            fullMask: '+34(###)###-###',
            fullLength: 11,
        },
        currency: {
            name: 'Spain',
            code: 'EUR',
            units: 0,
        },
        name: 'Spain',
        countryCode: '724',
        iso3166: 'ISO 3166-2:ES',
        region: 'Europe',
        subRegion: 'Southern Europe',
        intermediateRegion: '',
        regionCode: '150',
        subRegionCode: '039',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_spain',
        shortCountryNameKey: 'shortCountryNameKey_spain',
        code2: 'ES',
        code3: 'ESP',
    },
    {
        phone: {
            mask: '##-###-####',
            dialCode: '+94',
            length: 9,
            fullMask: '+94-##-###-####',
            fullLength: 11,
        },
        currency: {
            name: 'Sri Lanka Rupee',
            code: 'LKR',
            units: 2,
        },
        name: 'Sri Lanka',
        countryCode: '144',
        iso3166: 'ISO 3166-2:LK',
        region: 'Asia',
        subRegion: 'Southern Asia',
        intermediateRegion: '',
        regionCode: '142',
        subRegionCode: '034',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_sri_lanka',
        shortCountryNameKey: 'shortCountryNameKey_sri_lanka',
        code2: 'LK',
        code3: 'LKA',
    },
    {
        phone: {
            mask: '##-###-####',
            dialCode: '+249',
            length: 9,
            fullMask: '+249-##-###-####',
            fullLength: 12,
        },
        currency: {
            name: 'Sudan',
            code: 'USD',
            units: 0,
        },
        name: 'Sudan',
        countryCode: '729',
        iso3166: 'ISO 3166-2:SD',
        region: 'Africa',
        subRegion: 'Northern Africa',
        intermediateRegion: '',
        regionCode: '002',
        subRegionCode: '015',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_sudan',
        shortCountryNameKey: 'shortCountryNameKey_sudan',
        code2: 'SD',
        code3: 'SDN',
    },
    {
        phone: {
            mask: '###-###',
            dialCode: '+597',
            length: 6,
            fullMask: '+597-###-###',
            fullLength: 9,
        },
        currency: {
            name: 'Suriname',
            code: 'USD',
            units: 0,
        },
        name: 'Suriname',
        countryCode: '740',
        iso3166: 'ISO 3166-2:SR',
        region: 'Americas',
        subRegion: 'Latin America and the Caribbean',
        intermediateRegion: 'South America',
        regionCode: '019',
        subRegionCode: '419',
        intermediateRegionCode: '005',
        countryNameKey: 'countryNameKey_suriname',
        shortCountryNameKey: 'shortCountryNameKey_suriname',
        code2: 'SR',
        code3: 'SUR',
    },
    {
        phone: {
            mask: '##-##-####',
            dialCode: '+268',
            length: 8,
            fullMask: '+268-##-##-####',
            fullLength: 11,
        },
        currency: {
            name: 'Lilangeni',
            code: 'SZL',
            units: 2,
        },
        name: 'Eswatini',
        countryCode: '748',
        iso3166: 'ISO 3166-2:SZ',
        region: 'Africa',
        subRegion: 'Sub-Saharan Africa',
        intermediateRegion: 'Southern Africa',
        regionCode: '002',
        subRegionCode: '202',
        intermediateRegionCode: '018',
        countryNameKey: 'countryNameKey_swaziland',
        shortCountryNameKey: 'shortCountryNameKey_swaziland',
        code2: 'SZ',
        code3: 'SWZ',
    },
    {
        phone: {
            mask: '##-###-####',
            dialCode: '+46',
            length: 9,
            fullMask: '+46-##-###-####',
            fullLength: 11,
        },
        currency: {
            name: 'Swedish Krona',
            code: 'SEK',
            units: 2,
        },
        name: 'Sweden',
        countryCode: '752',
        iso3166: 'ISO 3166-2:SE',
        region: 'Europe',
        subRegion: 'Northern Europe',
        intermediateRegion: '',
        regionCode: '150',
        subRegionCode: '154',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_sweden',
        shortCountryNameKey: 'shortCountryNameKey_sweden',
        code2: 'SE',
        code3: 'SWE',
    },
    {
        phone: {
            mask: '##-###-####',
            dialCode: '+41',
            length: 9,
            fullMask: '+41-##-###-####',
            fullLength: 11,
        },
        currency: {
            name: 'Swiss Franc',
            code: 'CHF',
            units: 2,
        },
        name: 'Switzerland',
        countryCode: '756',
        iso3166: 'ISO 3166-2:CH',
        region: 'Europe',
        subRegion: 'Western Europe',
        intermediateRegion: '',
        regionCode: '150',
        subRegionCode: '155',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_switzerland',
        shortCountryNameKey: 'shortCountryNameKey_switzerland',
        code2: 'CH',
        code3: 'CHE',
    },
    {
        phone: {
            mask: '##-####-###',
            dialCode: '+963',
            length: 9,
            fullMask: '+963-##-####-###',
            fullLength: 12,
        },
        currency: {
            name: 'Syrian Pound',
            code: 'SYP',
            units: 2,
        },
        name: 'Syrian Arab Republic',
        countryCode: '760',
        iso3166: 'ISO 3166-2:SY',
        region: 'Asia',
        subRegion: 'Western Asia',
        intermediateRegion: '',
        regionCode: '142',
        subRegionCode: '145',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_syrian_arab_republic',
        shortCountryNameKey: 'shortCountryNameKey_syrian_arab_republic',
        code2: 'SY',
        code3: 'SYR',
    },
    {
        phone: {
            mask: '####-####',
            dialCode: '+886',
            length: 8,
            fullMask: '+886-####-####',
            fullLength: 11,
        },
        currency: {
            name: 'Taiwan',
            code: 'TWD',
            units: 0,
        },
        name: 'Taiwan, Province of China',
        countryCode: '158',
        iso3166: 'ISO 3166-2:TW',
        region: 'Asia',
        subRegion: 'Eastern Asia',
        intermediateRegion: '',
        regionCode: '142',
        subRegionCode: '030',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_taiwan',
        shortCountryNameKey: 'shortCountryNameKey_taiwan',
        code2: 'TW',
        code3: 'TWN',
    },
    {
        phone: {
            mask: '##-###-####',
            dialCode: '+992',
            length: 9,
            fullMask: '+992-##-###-####',
            fullLength: 12,
        },
        currency: {
            name: 'Tajikistan',
            code: 'TJS',
            units: 0,
        },
        name: 'Tajikistan',
        countryCode: '762',
        iso3166: 'ISO 3166-2:TJ',
        region: 'Asia',
        subRegion: 'Central Asia',
        intermediateRegion: '',
        regionCode: '142',
        subRegionCode: '143',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_tajikistan',
        shortCountryNameKey: 'shortCountryNameKey_tajikistan',
        code2: 'TJ',
        code3: 'TJK',
    },
    {
        phone: {
            mask: '##-###-####',
            dialCode: '+255',
            length: 9,
            fullMask: '+255-##-###-####',
            fullLength: 12,
        },
        currency: {
            name: 'Tanzanian Shilling',
            code: 'TZS',
            units: 2,
        },
        name: 'Tanzania, United Republic of',
        countryCode: '834',
        iso3166: 'ISO 3166-2:TZ',
        region: 'Africa',
        subRegion: 'Sub-Saharan Africa',
        intermediateRegion: 'Eastern Africa',
        regionCode: '002',
        subRegionCode: '202',
        intermediateRegionCode: '014',
        countryNameKey: 'countryNameKey_tanzania',
        shortCountryNameKey: 'shortCountryNameKey_tanzania',
        code2: 'TZ',
        code3: 'TZA',
    },
    {
        phone: {
            mask: '##-###-###',
            dialCode: '+66',
            length: 8,
            fullMask: '+66-##-###-###',
            fullLength: 10,
        },
        currency: {
            name: 'Baht',
            code: 'THB',
            units: 2,
        },
        name: 'Thailand',
        countryCode: '764',
        iso3166: 'ISO 3166-2:TH',
        region: 'Asia',
        subRegion: 'South-eastern Asia',
        intermediateRegion: '',
        regionCode: '142',
        subRegionCode: '035',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_thailand',
        shortCountryNameKey: 'shortCountryNameKey_thailand',
        code2: 'TH',
        code3: 'THA',
    },
    {
        phone: {
            mask: '##-###-###',
            dialCode: '+228',
            length: 8,
            fullMask: '+228-##-###-###',
            fullLength: 11,
        },
        currency: {
            name: 'Togo',
            code: 'USD',
            units: 0,
        },
        name: 'Togo',
        countryCode: '768',
        iso3166: 'ISO 3166-2:TG',
        region: 'Africa',
        subRegion: 'Sub-Saharan Africa',
        intermediateRegion: 'Western Africa',
        regionCode: '002',
        subRegionCode: '202',
        intermediateRegionCode: '011',
        countryNameKey: 'countryNameKey_togo',
        shortCountryNameKey: 'shortCountryNameKey_togo',
        code2: 'TG',
        code3: 'TGO',
    },
    {
        phone: {
            mask: '####',
            dialCode: '+690',
            length: 4,
            fullMask: '+690-####',
            fullLength: 7,
        },
        currency: {
            name: 'Tokelau',
            code: 'USD',
            units: 0,
        },
        name: 'Tokelau',
        countryCode: '772',
        iso3166: 'ISO 3166-2:TK',
        region: 'Oceania',
        subRegion: 'Polynesia',
        intermediateRegion: '',
        regionCode: '009',
        subRegionCode: '061',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_tokelau',
        shortCountryNameKey: 'shortCountryNameKey_tokelau',
        code2: 'TK',
        code3: 'TKL',
    },
    {
        phone: {
            mask: '#####',
            dialCode: '+676',
            length: 5,
            fullMask: '+676-#####',
            fullLength: 8,
        },
        currency: {
            name: 'Paêanga',
            code: 'TOP',
            units: 2,
        },
        name: 'Tonga',
        countryCode: '776',
        iso3166: 'ISO 3166-2:TO',
        region: 'Oceania',
        subRegion: 'Polynesia',
        intermediateRegion: '',
        regionCode: '009',
        subRegionCode: '061',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_tonga',
        shortCountryNameKey: 'shortCountryNameKey_tonga',
        code2: 'TO',
        code3: 'TON',
    },
    {
        phone: {
            mask: '###-####',
            dialCode: '+1868',
            length: 7,
            fullMask: '+1(868)###-####',
            fullLength: 11,
        },
        currency: {
            name: 'Trinidad and Tobago Dollar',
            code: 'TTD',
            units: 2,
        },
        name: 'Trinidad and Tobago',
        countryCode: '780',
        iso3166: 'ISO 3166-2:TT',
        region: 'Americas',
        subRegion: 'Latin America and the Caribbean',
        intermediateRegion: 'Caribbean',
        regionCode: '019',
        subRegionCode: '419',
        intermediateRegionCode: '029',
        countryNameKey: 'countryNameKey_trinidad_&_tobago',
        shortCountryNameKey: 'shortCountryNameKey_trinidad_&_tobago',
        code2: 'TT',
        code3: 'TTO',
    },
    {
        phone: {
            mask: '##-###-###',
            dialCode: '+216',
            length: 8,
            fullMask: '+216-##-###-###',
            fullLength: 11,
        },
        currency: {
            name: 'Tunisian Dinar',
            code: 'TND',
            units: 3,
        },
        name: 'Tunisia',
        countryCode: '788',
        iso3166: 'ISO 3166-2:TN',
        region: 'Africa',
        subRegion: 'Northern Africa',
        intermediateRegion: '',
        regionCode: '002',
        subRegionCode: '015',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_tunisia',
        shortCountryNameKey: 'shortCountryNameKey_tunisia',
        code2: 'TN',
        code3: 'TUN',
    },
    {
        phone: {
            mask: '(###)###-####',
            dialCode: '+90',
            length: 10,
            fullMask: '+90(###)###-####',
            fullLength: 12,
        },
        currency: {
            name: 'Turkey',
            code: 'TRY',
            units: 0,
        },
        name: 'Turkey',
        countryCode: '792',
        iso3166: 'ISO 3166-2:TR',
        region: 'Asia',
        subRegion: 'Western Asia',
        intermediateRegion: '',
        regionCode: '142',
        subRegionCode: '145',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_turkey',
        shortCountryNameKey: 'shortCountryNameKey_turkey',
        code2: 'TR',
        code3: 'TUR',
    },
    {
        phone: {
            mask: '#-###-####',
            dialCode: '+993',
            length: 8,
            fullMask: '+993-#-###-####',
            fullLength: 11,
        },
        currency: {
            name: 'Turkmenistan',
            code: 'USD',
            units: 0,
        },
        name: 'Turkmenistan',
        countryCode: '795',
        iso3166: 'ISO 3166-2:TM',
        region: 'Asia',
        subRegion: 'Central Asia',
        intermediateRegion: '',
        regionCode: '142',
        subRegionCode: '143',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_turkmenistan',
        shortCountryNameKey: 'shortCountryNameKey_turkmenistan',
        code2: 'TM',
        code3: 'TKM',
    },
    {
        phone: {
            mask: '###-####',
            dialCode: '+1649',
            length: 7,
            fullMask: '+1(649)###-####',
            fullLength: 11,
        },
        currency: {
            name: 'Turks and Caicos Islands',
            code: 'USD',
            units: 0,
        },
        name: 'Turks and Caicos Islands',
        countryCode: '796',
        iso3166: 'ISO 3166-2:TC',
        region: 'Americas',
        subRegion: 'Latin America and the Caribbean',
        intermediateRegion: 'Caribbean',
        regionCode: '019',
        subRegionCode: '419',
        intermediateRegionCode: '029',
        countryNameKey: 'countryNameKey_turks_&_caicos',
        shortCountryNameKey: 'shortCountryNameKey_turks_&_caicos',
        code2: 'TC',
        code3: 'TCA',
    },
    {
        phone: {
            mask: '####',
            dialCode: '+6882',
            length: 4,
            fullMask: '+688-2####',
            fullLength: 8,
        },
        currency: {
            name: 'Tuvalu',
            code: 'USD',
            units: 0,
        },
        name: 'Tuvalu',
        countryCode: '798',
        iso3166: 'ISO 3166-2:TV',
        region: 'Oceania',
        subRegion: 'Polynesia',
        intermediateRegion: '',
        regionCode: '009',
        subRegionCode: '061',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_tuvalu',
        shortCountryNameKey: 'shortCountryNameKey_tuvalu',
        code2: 'TV',
        code3: 'TUV',
    },
    {
        phone: {
            mask: '###-####',
            dialCode: '+1340',
            length: 7,
            fullMask: '+1(340)###-####',
            fullLength: 11,
        },
        currency: {
            name: 'Virgin Islands (U.S.)',
            code: 'USD',
            units: 0,
        },
        name: 'Virgin Islands (U.S.)',
        countryCode: '850',
        iso3166: 'ISO 3166-2:VI',
        region: 'Americas',
        subRegion: 'Latin America and the Caribbean',
        intermediateRegion: 'Caribbean',
        regionCode: '019',
        subRegionCode: '419',
        intermediateRegionCode: '029',
        countryNameKey: 'countryNameKey_us_virgin_islands',
        shortCountryNameKey: 'shortCountryNameKey_us_virgin_islands',
        code2: 'VI',
        code3: 'VIR',
    },
    {
        phone: {
            mask: '(###)###-###',
            dialCode: '+256',
            length: 9,
            fullMask: '+256(###)###-###',
            fullLength: 12,
        },
        currency: {
            name: 'Uganda Shilling',
            code: 'UGX',
            units: 0,
        },
        name: 'Uganda',
        countryCode: '800',
        iso3166: 'ISO 3166-2:UG',
        region: 'Africa',
        subRegion: 'Sub-Saharan Africa',
        intermediateRegion: 'Eastern Africa',
        regionCode: '002',
        subRegionCode: '202',
        intermediateRegionCode: '014',
        countryNameKey: 'countryNameKey_uganda',
        shortCountryNameKey: 'shortCountryNameKey_uganda',
        code2: 'UG',
        code3: 'UGA',
    },
    {
        phone: {
            mask: '(###)###-##-##',
            dialCode: '+38',
            length: 10,
            fullMask: '+38(###)###-##-##',
            fullLength: 12,
        },
        currency: {
            name: 'Ukraine',
            code: 'UAH',
            units: 0,
        },
        name: 'Ukraine',
        countryCode: '804',
        iso3166: 'ISO 3166-2:UA',
        region: 'Europe',
        subRegion: 'Eastern Europe',
        intermediateRegion: '',
        regionCode: '150',
        subRegionCode: '151',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_ukraine',
        shortCountryNameKey: 'shortCountryNameKey_ukraine',
        code2: 'UA',
        code3: 'UKR',
    },
    {
        phone: {
            mask: '#-###-####',
            dialCode: '+971',
            length: 8,
            fullMask: '+971-#-###-####',
            fullLength: 11,
        },
        currency: {
            name: 'UAE Dirham',
            code: 'AED',
            units: 2,
        },
        name: 'United Arab Emirates',
        countryCode: '784',
        iso3166: 'ISO 3166-2:AE',
        region: 'Asia',
        subRegion: 'Western Asia',
        intermediateRegion: '',
        regionCode: '142',
        subRegionCode: '145',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_united_arab_emirates',
        shortCountryNameKey: 'shortCountryNameKey_united_arab_emirates',
        code2: 'AE',
        code3: 'ARE',
    },
    {
        phone: {
            mask: '(###)###-####',
            dialCode: '+1',
            length: 10,
            fullMask: '+1(###)###-####',
            fullLength: 11,
        },
        currency: {
            name: 'US Dollar',
            code: 'USD',
            units: 2,
        },
        name: 'United States of America',
        countryCode: '840',
        iso3166: 'ISO 3166-2:US',
        region: 'Americas',
        subRegion: 'Northern America',
        intermediateRegion: '',
        regionCode: '019',
        subRegionCode: '021',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_united_states',
        shortCountryNameKey: 'shortCountryNameKey_united_states',
        code2: 'US',
        code3: 'USA',
    },
    {
        phone: {
            mask: '#-###-##-##',
            dialCode: '+598',
            length: 8,
            fullMask: '+598-#-###-##-##',
            fullLength: 11,
        },
        currency: {
            name: 'Peso Uruguayo',
            code: 'UYU',
            units: 2,
        },
        name: 'Uruguay',
        countryCode: '858',
        iso3166: 'ISO 3166-2:UY',
        region: 'Americas',
        subRegion: 'Latin America and the Caribbean',
        intermediateRegion: 'South America',
        regionCode: '019',
        subRegionCode: '419',
        intermediateRegionCode: '005',
        countryNameKey: 'countryNameKey_uruguay',
        shortCountryNameKey: 'shortCountryNameKey_uruguay',
        code2: 'UY',
        code3: 'URY',
    },
    {
        phone: {
            mask: '##-###-####',
            dialCode: '+998',
            length: 9,
            fullMask: '+998-##-###-####',
            fullLength: 12,
        },
        currency: {
            name: 'Uzbekistan Sum',
            code: 'UZS',
            units: 2,
        },
        name: 'Uzbekistan',
        countryCode: '860',
        iso3166: 'ISO 3166-2:UZ',
        region: 'Asia',
        subRegion: 'Central Asia',
        intermediateRegion: '',
        regionCode: '142',
        subRegionCode: '143',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_uzbekistan',
        shortCountryNameKey: 'shortCountryNameKey_uzbekistan',
        code2: 'UZ',
        code3: 'UZB',
    },
    {
        phone: {
            mask: '#####',
            dialCode: '+678',
            length: 5,
            fullMask: '+678-#####',
            fullLength: 8,
        },
        currency: {
            name: 'Vatu',
            code: 'VUV',
            units: 0,
        },
        name: 'Vanuatu',
        countryCode: '548',
        iso3166: 'ISO 3166-2:VU',
        region: 'Oceania',
        subRegion: 'Melanesia',
        intermediateRegion: '',
        regionCode: '009',
        subRegionCode: '054',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_vanuatu',
        shortCountryNameKey: 'shortCountryNameKey_vanuatu',
        code2: 'VU',
        code3: 'VUT',
    },
    {
        phone: {
            mask: '#####',
            dialCode: '+396-698-',
            length: 5,
            fullMask: '+39-6-698-#####',
            fullLength: 13,
        },
        currency: {
            name: 'Holy See',
            code: 'USD',
            units: 0,
        },
        name: 'Holy See',
        countryCode: '336',
        iso3166: 'ISO 3166-2:VA',
        region: 'Europe',
        subRegion: 'Southern Europe',
        intermediateRegion: '',
        regionCode: '150',
        subRegionCode: '039',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_vatican_city',
        shortCountryNameKey: 'shortCountryNameKey_vatican_city',
        code2: 'VA',
        code3: 'VAT',
    },
    {
        phone: {
            mask: '(###)###-####',
            dialCode: '+58',
            length: 10,
            fullMask: '+58(###)###-####',
            fullLength: 12,
        },
        currency: {
            name: 'Venezuela (Bolivarian Republic of)',
            code: 'USD',
            units: 0,
        },
        name: 'Venezuela (Bolivarian Republic of)',
        countryCode: '862',
        iso3166: 'ISO 3166-2:VE',
        region: 'Americas',
        subRegion: 'Latin America and the Caribbean',
        intermediateRegion: 'South America',
        regionCode: '019',
        subRegionCode: '419',
        intermediateRegionCode: '005',
        countryNameKey: 'countryNameKey_venezuela',
        shortCountryNameKey: 'shortCountryNameKey_venezuela',
        code2: 'VE',
        code3: 'VEN',
    },
    {
        phone: {
            mask: '(###)####-###',
            dialCode: '+84',
            length: 10,
            fullMask: '+84(###)####-###',
            fullLength: 12,
        },
        currency: {
            name: 'Dong',
            code: 'VND',
            units: 0,
        },
        name: 'Viet Nam',
        countryCode: '704',
        iso3166: 'ISO 3166-2:VN',
        region: 'Asia',
        subRegion: 'South-eastern Asia',
        intermediateRegion: '',
        regionCode: '142',
        subRegionCode: '035',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_vietnam',
        shortCountryNameKey: 'shortCountryNameKey_vietnam',
        code2: 'VN',
        code3: 'VNM',
    },
    {
        phone: {
            mask: '##-####',
            dialCode: '+681',
            length: 6,
            fullMask: '+681-##-####',
            fullLength: 9,
        },
        currency: {
            name: 'Wallis and Futuna',
            code: 'USD',
            units: 0,
        },
        name: 'Wallis and Futuna',
        countryCode: '876',
        iso3166: 'ISO 3166-2:WF',
        region: 'Oceania',
        subRegion: 'Polynesia',
        intermediateRegion: '',
        regionCode: '009',
        subRegionCode: '061',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_wallis_and_futuna',
        shortCountryNameKey: 'shortCountryNameKey_wallis_and_futuna',
        code2: 'WF',
        code3: 'WLF',
    },
    {
        phone: {
            mask: '#-###-###',
            dialCode: '+967',
            length: 7,
            fullMask: '+967-#-###-###',
            fullLength: 10,
        },
        currency: {
            name: 'Yemen',
            code: 'YER',
            units: 0,
        },
        name: 'Yemen',
        countryCode: '887',
        iso3166: 'ISO 3166-2:YE',
        region: 'Asia',
        subRegion: 'Western Asia',
        intermediateRegion: '',
        regionCode: '142',
        subRegionCode: '145',
        intermediateRegionCode: '',
        countryNameKey: 'countryNameKey_yemen',
        shortCountryNameKey: 'shortCountryNameKey_yemen',
        code2: 'YE',
        code3: 'YEM',
    },
    {
        phone: {
            mask: '##-###-####',
            dialCode: '+260',
            length: 9,
            fullMask: '+260-##-###-####',
            fullLength: 12,
        },
        currency: {
            name: 'Zambia',
            code: 'USD',
            units: 0,
        },
        name: 'Zambia',
        countryCode: '894',
        iso3166: 'ISO 3166-2:ZM',
        region: 'Africa',
        subRegion: 'Sub-Saharan Africa',
        intermediateRegion: 'Eastern Africa',
        regionCode: '002',
        subRegionCode: '202',
        intermediateRegionCode: '014',
        countryNameKey: 'countryNameKey_zambia',
        shortCountryNameKey: 'shortCountryNameKey_zambia',
        code2: 'ZM',
        code3: 'ZMB',
    },
    {
        phone: {
            mask: '#-######',
            dialCode: '+263',
            length: 7,
            fullMask: '+263-#-######',
            fullLength: 10,
        },
        currency: {
            name: 'Zimbabwe',
            code: 'USD',
            units: 0,
        },
        name: 'Zimbabwe',
        countryCode: '716',
        iso3166: 'ISO 3166-2:ZW',
        region: 'Africa',
        subRegion: 'Sub-Saharan Africa',
        intermediateRegion: 'Eastern Africa',
        regionCode: '002',
        subRegionCode: '202',
        intermediateRegionCode: '014',
        countryNameKey: 'countryNameKey_zimbabwe',
        shortCountryNameKey: 'shortCountryNameKey_zimbabwe',
        code2: 'ZW',
        code3: 'ZWE',
    },
];
